import {
  initSaveUsers,
  resetAllowAccess,
  resetAllowSubAccess,
  setActivateCalendarNotifications,
  setActivateCarteNotifications,
  setActivateNotifications,
  setAllowAccess,
  setAllowAccessBalanceRecap,
  setAllowAccessBonusPlan,
  setAllowAccessCalendar,
  setAllowAccessCalendarSetting,
  setAllowAccessCapacityPlanning,
  setAllowAccessCapacityPlanningTab,
  setAllowAccessCategorySetting,
  setAllowAccessClientSpace,
  setAllowAccessCollaboratorSetting,
  setAllowAccessCroissance,
  setAllowAccessDynamicTable,
  setAllowAccessEcheance,
  setAllowAccessErrorReporting,
  setAllowAccessFinancial,
  setAllowAccessFinancialSheet,
  setAllowAccessForfait,
  setAllowAccessModelSetting,
  setAllowAccessParameterSetting,
  setAllowAccessPlans,
  setAllowAccessPortfolios,
  setAllowAccessPrestations,
  setAllowAccessPrestaTS,
  setAllowAccessProductionCapacity,
  setAllowAccessReporting,
  setAllowAccessReportingTab,
  setAllowAccessSetting,
  setAllowAccessSynchronization,
  setAllowAccessSynthesis,
  setAllowAccessTaskTypeSetting,
  setAllowAccessTimeReport,
  setAllowAccessToClientCollaboratorRelation,
  setAllowAccessToClientInformations,
  setAllowAccessToClientList,
  setAllowAccessToCollaboratorList,
  setAllowAccessToCorrectionCards,
  setAllowAccessToGlobalBudget,
  setAllowAccessToStatisticsCards,
  setAllowAccessUserSetting,
  setAllowAccessVacationMatrix,
  setAllowAdjustDistributionOfTasksByRole,
  setAllowAttributionBU,
  setAllowAttributionCluster,
  setAllowAttributionSquad,
  setAllowCoefficientsConfig,
  setAllowCollabToDevCard,
  setAllowConfigurateBudget,
  setAllowCreateCorrectionCards,
  setAllowSelectAppliedModel,
  setAllowSubAccess,
  setAllowToAddDeleger,
  setAllowTodragAndDropFromDONE,
  setAllowTodragAndDropFromTODO,
  setAllowTodragAndDropFromVALIDATION,
  setAllowTodragAndDropFromWIP,
  setAllowUpdateBudgetedBenchmark,
  setAllowUpdatingBillingView,
  setAllowUpdatingDepartClients,
  setAllowUpdatingNewClients,
  setAllowUpdatingOffrePrice,
  setAllowUpdatingTarifClients,
  setAllowViewDataBy,
  setAllowViewSubDataBy,
  setAllowVisualizationOfBudgetedBenchmark,
  setAllowVisualizationOfBudgetedTime,
  setAllowVisualizationOfRealizedBenchmark,
  setAllowVisualizationOfRealizedTime,
  setDefaultAuthParameters,
  setRole,
  setSelectedUsers,
  setAllowViewSubDataListBy,
  toggleViewDataBy,
  toggleViewSubDataBy,
  toggleViewDataListBy
} from "actions";
import { Collapse, Radio, Checkbox } from "antd";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import classnames from "classnames";
import { TTP_API_URL } from "Config";
import _ from "i18n";
import moment from "moment";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { selectLoggedAs } from "Selectors";
import {
  fetchParameterSettings,
  fetchUsers,
  updateUsersSettings
} from "thunks";
import { getUserNameForAvatar, inIframe, isSuperAdminAccess } from "Utils";
import MultiSwitch from "../Common/Switch/MultiSwitch";
import Switch from "../Common/Switch/Switch";
import styles from "./Authorizations.local.scss";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: moment().year(),
      expanded: false
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const { year } = this.state;
    dispatch(fetchParameterSettings(year));
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedUsers, dispatch } = this.props;
    if (
      !!selectedUsers &&
      selectedUsers.length !== 0 &&
      prevProps.selectedUsers !== selectedUsers
    ) {
      if (selectedUsers.length > 1) {
        // Gestion de la multi select

        let roles = [];
        // eslint-disable-next-line array-callback-return
        selectedUsers.map((item, i) => {
          let role = item.accountingAuthorization.role
            ? item.accountingAuthorization.role
            : "NONE";
          if (!roles.includes(role)) {
            roles.push(role);
          }
        });

        let withoutPreferences = true;
        let allowConfigurateBudget = false;
        let allowUpdatingBillingView = false;
        let allowUpdatingTarifClients = false;
        let allowUpdatingNewClients = false;
        let allowUpdatingDepartClients = false;
        let allowAccessToCorrectionCards = false;
        let allowVisualizationOfBudgetedTime = false;
        let allowVisualizationOfBudgetedBenchmark = false;
        let allowVisualizationOfRealizedTime = false;
        let allowVisualizationOfRealizedBenchmark = false;
        let allowAccessToClientCollaboratorRelation = false;
        let allowAccessToClientInformations = false;
        let allowAccessToGlobalBudget = false;
        let allowUpdatingOffrePrice = false;
        let allowToAddDeleger = false;
        let allowUpdateBudgetedBenchmark = false;
        let allowAccessToStatisticsCards = false;

        let allowAdjustDistributionOfTasksByRole = false;
        let allowAttributionBU = false;
        let allowAttributionSquad = false;
        let allowCollabToDevCard = false;
        let allowAttributionCluster = false;
        let allowSelectAppliedModel = false;
        let allowTodragAndDropFromTODO = false;
        let allowTodragAndDropFromWIP = false;
        let allowTodragAndDropFromDONE = false;
        let allowTodragAndDropFromVALIDATION = false;

        let allowAccessClientSpace = false;
        let allowAccess = false;
        let allowCreateCorrectionCards = false;
        let allowAccessToCollaboratorList = false;
        let activateNotification = false;
        let activateCarteNotification = false;
        let activateCalendarNotification = false;

        // reporting init
        let allowAccessReporting = false;
        let allowAccessReportingTab = false;
        let allowAccessProdCapacity = false;
        let allowAccessBonusPlan = false;
        let allowAccessEcheance = false;
        let allowAccessBalanceRecap = false;
        let allowAccessCalendar = false;
        let allowAccessTimeReport = false;
        let allowAccessPortfolio = false;
        let allowAccessErrReporting = false;
        let allowAccessVacationMatrix = false;
        let allowAccessPlans = false;
        let allowAccessPrestation = false;

        let allowAccessPrestaTS = false;
        let allowAccessFinancial = false;
        let allowAccessFinancialSheet = false;
        let allowAccessForfait = false;
        let allowAccessCroissance = false;
        let allowAccessDynamicTab = false;

        let allowAccessCapacityPlanning = false;
        let allowAccessCapacityPlanningTab = false;
        let allowAccessSynthesis = false;

        let allowAccessSetting = false;
        let allowAccessCategorySetting = false;
        let allowAccessTaskTypeSetting = false;
        let allowAccessCollaboratorSetting = false;
        let allowAccessCalendarSetting = false;
        let allowCoefficientsConfig = false;
        let allowAccessModelSetting = false;
        let allowAccessUserSetting = false;
        let allowAccessSynchronization = false;
        let allowAccessParameterSetting = false;

        // new access setting
        let dashboard = {
          allowAccess: false
        };

        let clients = {
          allowAccess: false,
          allowViewDataBy: 0,
          allowUpdateBudgetConfig: false,
          allowUpdateClientSettings: false
        };

        let collaborators = {
          allowAccess: false,
          allowConfigCollaborator: false,
          allowViewDataBy: 0,
          allowAccessCPr: false,
          allowAccessPlans: false,
          allowDragFromToDo: false,
          allowDragFromWIP: false,
          allowDragFromValidate: false,
          allowDragFromDone: false,
          allowAccessCalendar: false,
          allowValidateVacationRequest: false,
          allowAccessPlanification: false,
          allowAccessFolderCapacity: false,
          allowAccessFinancialState: false,
          allowVerifyBudget: false
        };

        let financial = {
          allowAccess: false,
          allowAccessFinancial: false,
          allowViewDataFinancialBy: 0,
          allowAccessForfait: false,
          allowLaunchRevision: false,
          allowAccessCroissance: false,
          allowViewDataCroissanceBy: 0,
          allowAccessIN: false,
          allowAccessOUT: false,
          allowAccessRisky: false,
          allowAccessReview: false,
          allowAccessDynamicTable: false,
          allowViewDataDynamicTableBy: 0
        };

        let prestations = {
          allowAccess: false,
          allowViewDataBy: 0
        };

        const reporting = {
          allowAccess: false,
          allowAccessCardsStatistics: false,
          allowAccessProduction: false,
          allowViewProductionDataBy: 0,
          allowAccessIndividualDevBe: false,
          allowViewIndividualDevBeDataBy: 0,
          allowAccessIndividualDevMa: false,
          allowViewIndividualDevMaDataBy: 0,
          allowAccessEcheance: false,
          allowViewEcheanceDataBy: 0,
          allowAccessRecapBalance: false,
          allowViewRecapBalanceDataBy: 0,
          allowAccessCalendar: false,
          allowViewCalendarDataBy: 0,
          allowAccessTimesheet: false,
          allowViewTimesheetDataBy: 0,
          allowAccessPortfolio: false,
          allowViewPortfolioDataBy: 0,
          allowAccessSupervision: false,
          allowViewSupervisionDataBy: 0,
          allowAccessVacation: false,
          allowViewVacationDataBy: 0,
          allowAccessPlans: false,
          allowViewPlansDataBy: 0,
          allowAccessPrestations: false,
          allowViewPrestationsDataBy: 0
        };

        let capacityPlanning = {
          allowAccess: false,
          allowViewDataBy: 0
        };

        let settings = {
          allowAccess: false,
          allowAccessCategories: false,
          allowAccessTaskTypes: false,
          allowAccessCollaborators: false,
          allowAccessCalendar: false,
          allowAccessModels: false,
          allowAccessUsers: false,
          allowAccessSynchronization: false,
          allowAccessParameters: false
        };

        let timesheet = {
          allowAccess: false,
          allowViewDataBy: 0
        };

        if (roles.length === 1) {
          roles = roles[0];

          if (roles === "MANAGER") {
            const authorisations = selectedUsers[0].accountingAuthorization;

            withoutPreferences = false;
            // eslint-disable-next-line array-callback-return
            selectedUsers.map((item, i) => {
              if (
                JSON.stringify(item.accountingAuthorization.preferences) !==
                JSON.stringify(authorisations.preferences)
              ) {
                withoutPreferences = true;
                return false;
              }
            });

            /**
             * @deprecated
             * Use @recommended instead
             */
            allowUpdatingBillingView = !(
              withoutPreferences ||
              authorisations.preferences.allowUpdatingBillingView === "0"
            );
            allowUpdatingTarifClients = !(
              withoutPreferences ||
              authorisations.preferences.allowUpdatingTarifClients === "0"
            );
            allowUpdatingNewClients = !(
              withoutPreferences ||
              authorisations.preferences.allowUpdatingNewClients === "0"
            );
            allowUpdatingDepartClients = !(
              withoutPreferences ||
              authorisations.preferences.allowUpdatingDepartClients === "0"
            );
            allowConfigurateBudget = !(
              withoutPreferences ||
              authorisations.preferences.allowConfigurateBudget === "0"
            );
            allowAccessToClientCollaboratorRelation = !(
              withoutPreferences ||
              authorisations.preferences
                .allowAccessToClientCollaboratorRelation === "0"
            );
            allowAccessToClientInformations = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessToClientInformations === "0"
            );
            allowAccessToGlobalBudget = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessToGlobalBudget === "0"
            );
            allowUpdatingOffrePrice = !(
              withoutPreferences ||
              authorisations.preferences.allowUpdatingOffrePrice === "0"
            );
            allowToAddDeleger = !(
              withoutPreferences ||
              authorisations.preferences.allowToAddDeleger === "0"
            );
            allowUpdateBudgetedBenchmark = !(
              withoutPreferences ||
              authorisations.preferences.allowUpdateBudgetedBenchmark === "0"
            );
            allowAccessToStatisticsCards = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessToStatisticsCards === "0"
            );
            allowAccessToCorrectionCards = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessToCorrectionCards === "0"
            );
            allowVisualizationOfBudgetedTime = !(
              withoutPreferences ||
              authorisations.preferences.allowVisualizationOfBudgetedTime ===
                "0"
            );
            allowVisualizationOfBudgetedBenchmark = !(
              withoutPreferences ||
              authorisations.preferences
                .allowVisualizationOfBudgetedBenchmark === "0"
            );
            allowVisualizationOfRealizedTime = !(
              withoutPreferences ||
              authorisations.preferences.allowVisualizationOfRealizedTime ===
                "0"
            );
            allowVisualizationOfRealizedBenchmark = !(
              withoutPreferences ||
              authorisations.preferences
                .allowVisualizationOfRealizedBenchmark === "0"
            );

            allowAdjustDistributionOfTasksByRole = !(
              withoutPreferences ||
              authorisations.preferences
                .allowAdjustDistributionOfTasksByRole === "0"
            );
            allowAttributionBU = !(
              withoutPreferences ||
              authorisations.preferences.allowAttributionBU === "0"
            );
            allowAttributionSquad = !(
              withoutPreferences ||
              authorisations.preferences.allowAttributionSquad === "0"
            );
            allowCollabToDevCard = !(
              withoutPreferences ||
              authorisations.preferences.allowCollabToDevCard === "0"
            );
            allowAttributionCluster = !(
              withoutPreferences ||
              authorisations.preferences.allowAttributionCluster === "0"
            );
            allowSelectAppliedModel = !(
              withoutPreferences ||
              authorisations.preferences.allowSelectAppliedModel === "0"
            );
            allowTodragAndDropFromTODO = !(
              withoutPreferences ||
              authorisations.preferences.allowTodragAndDropFromTODO === "0"
            );
            allowTodragAndDropFromWIP = !(
              withoutPreferences ||
              authorisations.preferences.allowTodragAndDropFromWIP === "0"
            );
            allowTodragAndDropFromDONE = !(
              withoutPreferences ||
              authorisations.preferences.allowTodragAndDropFromDONE === "0"
            );
            allowTodragAndDropFromVALIDATION = !(
              withoutPreferences ||
              authorisations.preferences.allowTodragAndDropFromVALIDATION ===
                "0"
            );

            allowAccess = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessToClientList === "0"
            );
            allowAccessToCollaboratorList = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessToCollaboratorList === "0"
            );
            allowAccessClientSpace = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessClientSpace === "0"
            );
            allowCreateCorrectionCards = !(
              withoutPreferences ||
              authorisations.preferences.allowCreateCorrectionCards === "0"
            );

            allowAccessReporting = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessReporting === "0"
            );
            allowAccessReportingTab = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessReportingTab === "0"
            );
            allowAccessProdCapacity = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessProdCapacity === "0"
            );
            allowAccessBonusPlan = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessBonusPlan === "0"
            );
            allowAccessEcheance = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessEcheance === "0"
            );
            allowAccessBalanceRecap = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessBalanceRecap === "0"
            );
            allowAccessCalendar = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessCalendar === "0"
            );
            allowAccessTimeReport = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessTimeReport === "0"
            );
            allowAccessPortfolio = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessPortfolio === "0"
            );
            allowAccessErrReporting = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessErrReporting === "0"
            );
            allowAccessVacationMatrix = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessVacationMatrix === "0"
            );
            allowAccessPlans = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessPlans === "0"
            );
            allowAccessPrestation = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessPrestation === "0"
            );

            allowAccessPrestaTS = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessPrestaTS === "0"
            );
            allowAccessFinancial = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessFinancial === "0"
            );
            allowAccessFinancialSheet = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessFinancialSheet === "0"
            );
            allowAccessForfait = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessForfait === "0"
            );
            allowAccessCroissance = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessCroissance === "0"
            );
            allowAccessDynamicTab = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessDynamicTab === "0"
            );
            allowAccessCapacityPlanning = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessCapacityPlanning === "0"
            );
            allowAccessCapacityPlanningTab = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessCapacityPlanningTab === "0"
            );
            allowAccessSynthesis = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessSynthesis === "0"
            );

            allowAccessSetting = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessSetting === "0"
            );
            allowAccessCategorySetting = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessCategorySetting === "0"
            );
            allowAccessTaskTypeSetting = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessTaskTypeSetting === "0"
            );
            allowAccessCollaboratorSetting = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessCollaboratorSetting === "0"
            );
            allowAccessCalendarSetting = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessCalendarSetting === "0"
            );
            allowCoefficientsConfig = !(
              withoutPreferences ||
              authorisations.preferences.allowCoefficientsConfig === "0"
            );
            allowAccessModelSetting = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessModelSetting === "0"
            );
            allowAccessUserSetting = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessUserSetting === "0"
            );
            allowAccessSynchronization = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessSynchronization === "0"
            );
            allowAccessParameterSetting = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessParameterSetting === "0"
            );

            const dashboardPreferences = JSON.parse(
              authorisations.preferences.dashboard
            );
            const clientsPreferences = JSON.parse(
              authorisations.preferences.clients
            );
            const collaboratorsPreferences = JSON.parse(
              authorisations.preferences.collaborators
            );
            const prestationsPreferences = JSON.parse(
              authorisations.preferences.prestations
            );
            const financialPreferences = JSON.parse(
              authorisations.preferences.financial
            );
            const reportingPreferences = JSON.parse(
              authorisations.preferences.reporting
            );
            const capacityPlanningPreferences = JSON.parse(
              authorisations.preferences.capacityPlanning
            );
            const settingsPreferences = JSON.parse(
              authorisations.preferences.settings
            );
            const timesheetPreferences = JSON.parse(
              authorisations.preferences.timesheet
            );

            /**
             * @recommended
             */
            activateNotification = !(
              withoutPreferences ||
              !authorisations.preferences.activateNotifications
            );
            activateCarteNotification = !(
              withoutPreferences ||
              !authorisations.preferences.activateCarteNotification
            );
            activateCalendarNotification = !(
              withoutPreferences ||
              !authorisations.preferences.activateCalendarNotification
            );

            dashboard.allowAccess = !(
              withoutPreferences || !dashboardPreferences.allowAccess
            );

            clients.allowAccess = !(
              withoutPreferences || !clientsPreferences.allowAccess
            );
            clients.allowViewDataBy = clientsPreferences.allowViewDataBy;
            clients.allowUpdateBudgetConfig = !(
              withoutPreferences || !clientsPreferences.allowUpdateBudgetConfig
            );
            clients.allowUpdateClientSettings = !(
              withoutPreferences ||
              !clientsPreferences.allowUpdateClientSettings
            );

            collaborators.allowAccess = !(
              withoutPreferences || !collaboratorsPreferences.allowAccess
            );
            collaborators.allowConfigCollaborator = !(
              withoutPreferences ||
              !collaboratorsPreferences.allowConfigCollaborator
            );
            collaborators.allowViewDataBy =
              collaboratorsPreferences.allowViewDataBy;
            collaborators.allowAccessCPr = !(
              withoutPreferences || !collaboratorsPreferences.allowAccessCPr
            );
            collaborators.allowAccessPlans = !(
              withoutPreferences || !collaboratorsPreferences.allowAccessPlans
            );
            collaborators.allowDragFromToDo = !(
              withoutPreferences || !collaboratorsPreferences.allowDragFromToDo
            );
            collaborators.allowDragFromWIP = !(
              withoutPreferences || !collaboratorsPreferences.allowDragFromWIP
            );
            collaborators.allowDragFromValidate = !(
              withoutPreferences ||
              !collaboratorsPreferences.allowDragFromValidate
            );
            collaborators.allowDragFromDone = !(
              withoutPreferences || !collaboratorsPreferences.allowDragFromDone
            );
            collaborators.allowAccessCalendar = !(
              withoutPreferences ||
              !collaboratorsPreferences.allowAccessCalendar
            );
            collaborators.allowValidateVacationRequest = !(
              withoutPreferences ||
              !collaboratorsPreferences.allowValidateVacationRequest
            );
            collaborators.allowAccessPlanification = !(
              withoutPreferences ||
              !collaboratorsPreferences.allowAccessPlanification
            );
            collaborators.allowAccessFolderCapacity = !(
              withoutPreferences ||
              !collaboratorsPreferences.allowAccessFolderCapacity
            );
            collaborators.allowAccessFinancialState = !(
              withoutPreferences ||
              !collaboratorsPreferences.allowAccessFinancialState
            );
            collaborators.allowVerifyBudget = !(
              withoutPreferences || !collaboratorsPreferences.allowVerifyBudget
            );
            financial.allowAccess = !(
              withoutPreferences || !financialPreferences.allowAccess
            );
            financial.allowAccessFinancial = !(
              withoutPreferences ||
              !financialPreferences.financialState.allowAccess
            );
            financial.allowViewDataFinancialBy =
              financialPreferences.financialState.allowViewDataBy;
            financial.allowAccessForfait = !(
              withoutPreferences || !financialPreferences.forfait.allowAccess
            );
            financial.allowLaunchRevision = !(
              withoutPreferences ||
              !financialPreferences.forfait.allowLaunchRevision
            );
            financial.allowAccessCroissance = !(
              withoutPreferences || !financialPreferences.croissance.allowAccess
            );
            financial.allowViewDataCroissanceBy =
              financialPreferences.croissance.allowViewDataBy;
            financial.allowAccessIN = !(
              withoutPreferences ||
              !financialPreferences.croissance.allowAccessIN
            );
            financial.allowAccessOUT = !(
              withoutPreferences ||
              !financialPreferences.croissance.allowAccessOUT
            );
            financial.allowAccessRisky = !(
              withoutPreferences ||
              !financialPreferences.croissance.allowAccessRisky
            );
            financial.allowAccessReview = !(
              withoutPreferences ||
              !financialPreferences.croissance.allowAccessReview
            );
            financial.allowAccessDynamicTable = !(
              withoutPreferences ||
              !financialPreferences.dynamicTable.allowAccess
            );
            financial.allowViewDataDynamicTableBy =
              financialPreferences.dynamicTable.allowViewDataBy;

            prestations.allowAccess = !(
              withoutPreferences || !prestationsPreferences.allowAccess
            );
            prestations.allowViewDataBy =
              prestationsPreferences.allowViewDataBy;

            reporting.allowAccess = !(
              withoutPreferences || !reportingPreferences.allowAccess
            );

            reporting.allowAccessProduction = !(
              withoutPreferences || !reportingPreferences.production.allowAccess
            );
            reporting.allowAccessCardsStatistics = !(
              withoutPreferences ||
              !reportingPreferences.allowAccessCardsStatistics
            );
            reporting.allowViewProductionDataBy =
              reportingPreferences.production.allowViewDataBy;

            reporting.allowAccessIndividualDevBe = !(
              withoutPreferences ||
              !reportingPreferences.individualDevBe.allowAccess
            );
            reporting.allowViewIndividualDevBeDataBy =
              reportingPreferences.individualDevBe.allowViewDataBy;

            reporting.allowAccessIndividualDevMa = !(
              withoutPreferences ||
              !reportingPreferences.individualDevMa.allowAccess
            );
            reporting.allowViewIndividualDevMaDataBy =
              reportingPreferences.individualDevMa.allowViewDataBy;

            reporting.allowAccessEcheance = !(
              withoutPreferences || !reportingPreferences.echeance.allowAccess
            );
            reporting.allowViewEcheanceDataBy =
              reportingPreferences.echeance.allowViewDataBy;

            reporting.allowAccessRecapBalance = !(
              withoutPreferences ||
              !reportingPreferences.recapBalance.allowAccess
            );
            reporting.allowViewRecapBalanceDataBy =
              reportingPreferences.recapBalance.allowViewDataBy;

            reporting.allowAccessCalendar = !(
              withoutPreferences || !reportingPreferences.calendar.allowAccess
            );
            reporting.allowViewCalendarDataBy =
              reportingPreferences.calendar.allowViewDataBy;

            reporting.allowAccessTimesheet = !(
              withoutPreferences || !reportingPreferences.timesheet.allowAccess
            );
            reporting.allowViewTimesheetDataBy =
              reportingPreferences.timesheet.allowViewDataBy;

            reporting.allowAccessPortfolio = !(
              withoutPreferences || !reportingPreferences.portfolio.allowAccess
            );
            reporting.allowViewPortfolioDataBy =
              reportingPreferences.portfolio.allowViewDataBy;

            reporting.allowAccessSupervision = !(
              withoutPreferences ||
              !reportingPreferences.supervision.allowAccess
            );
            reporting.allowViewSupervisionDataBy =
              reportingPreferences.supervision.allowViewDataBy;

            reporting.allowAccessVacation = !(
              withoutPreferences || !reportingPreferences.vacation.allowAccess
            );
            reporting.allowViewVacationDataBy =
              reportingPreferences.vacation.allowViewDataBy;

            reporting.allowAccessPlans = !(
              withoutPreferences || !reportingPreferences.plans.allowAccess
            );
            reporting.allowViewPlansDataBy =
              reportingPreferences.plans.allowViewDataBy;

            reporting.allowAccessPrestations = !(
              withoutPreferences ||
              !reportingPreferences.prestations.allowAccess
            );
            reporting.allowViewPrestationsDataBy =
              reportingPreferences.prestations.allowViewDataBy;

            capacityPlanning.allowAccess = !(
              withoutPreferences || !capacityPlanningPreferences.allowAccess
            );
            capacityPlanning.allowViewDataBy =
              capacityPlanningPreferences.allowViewDataBy;

            settings.allowAccess = !(
              withoutPreferences || !settingsPreferences.allowAccess
            );
            settings.allowAccessCategories = !(
              withoutPreferences || !settingsPreferences.allowAccessCategories
            );
            settings.allowAccessParameters = !(
              withoutPreferences || !settingsPreferences.allowAccessParameters
            );
            settings.allowAccessTaskTypes = !(
              withoutPreferences || !settingsPreferences.allowAccessTasks
            );
            settings.allowAccessUsers = !(
              withoutPreferences || !settingsPreferences.allowAccessUsers
            );
            settings.allowAccessCalendar = !(
              withoutPreferences || !settingsPreferences.allowAccessCalendar
            );
            settings.allowAccessModels = !(
              withoutPreferences || !settingsPreferences.allowAccessModels
            );
            settings.allowAccessCollaborators = !(
              withoutPreferences ||
              !settingsPreferences.allowAccessCollaborators
            );
            settings.allowAccessSynchronization = !(
              withoutPreferences ||
              !settingsPreferences.allowAccessSynchronization
            );

            timesheet.allowAccess = !(
              withoutPreferences || !timesheetPreferences.allowAccess
            );
            timesheet.allowViewDataBy = timesheetPreferences.allowViewDataBy;
          }
        }

        dispatch(setActivateNotifications(activateNotification));
        dispatch(setActivateCarteNotifications(activateCarteNotification));
        dispatch(
          setActivateCalendarNotifications(activateCalendarNotification)
        );

        dispatch(
          setAllowAccess("dashboard", "allowAccess", dashboard.allowAccess)
        );

        dispatch(setAllowAccess("clients", "allowAccess", clients.allowAccess));
        dispatch(setAllowViewDataBy("clients", clients.allowViewDataBy));
        dispatch(
          setAllowAccess(
            "clients",
            "allowUpdateBudgetConfig",
            clients.allowUpdateBudgetConfig
          )
        );
        dispatch(
          setAllowAccess(
            "clients",
            "allowUpdateClientSettings",
            clients.allowUpdateClientSettings
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowAccess",
            collaborators.allowAccess
          )
        );
        dispatch(
          setAllowViewDataBy("collaborators", collaborators.allowViewDataBy)
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowConfigCollaborator",
            collaborators.allowConfigCollaborator
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowAccessCPr",
            collaborators.allowAccessCPr
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowAccessPlans",
            collaborators.allowAccessPlans
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowDragFromToDo",
            collaborators.allowDragFromToDo
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowDragFromWIP",
            collaborators.allowDragFromWIP
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowDragFromValidate",
            collaborators.allowDragFromValidate
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowDragFromDone",
            collaborators.allowDragFromDone
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowAccessCalendar",
            collaborators.allowAccessCalendar
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowValidateVacationRequest",
            collaborators.allowValidateVacationRequest
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowAccessPlanification",
            collaborators.allowAccessPlanification
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowAccessFolderCapacity",
            collaborators.allowAccessFolderCapacity
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowAccessFinancialState",
            collaborators.allowAccessFinancialState
          )
        );
        dispatch(
          setAllowAccess("financial", "allowAccess", financial.allowAccess)
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowVerifyBudget",
            collaborators.allowVerifyBudget
          )
        );
        dispatch(
          setAllowSubAccess(
            "financial",
            "financialState",
            "allowAccess",
            financial.allowAccessFinancial
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "financial",
            "financialState",
            financial.allowViewDataFinancialBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "financial",
            "forfait",
            "allowAccess",
            financial.allowAccessForfait
          )
        );
        dispatch(
          setAllowSubAccess(
            "financial",
            "forfait",
            "allowLaunchRevision",
            financial.allowLaunchRevision
          )
        );
        dispatch(
          setAllowSubAccess(
            "financial",
            "croissance",
            "allowAccess",
            financial.allowAccessCroissance
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "financial",
            "croissance",
            financial.allowViewDataCroissanceBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "financial",
            "croiss",
            "allowAccessIN",
            financial.allowAccessIN
          )
        );
        dispatch(
          setAllowSubAccess(
            "financial",
            "croissance",
            "allowAccessOUT",
            financial.allowAccessOUT
          )
        );
        dispatch(
          setAllowSubAccess(
            "financial",
            "croissance",
            "allowAccessRisky",
            financial.allowAccessRisky
          )
        );
        dispatch(
          setAllowSubAccess(
            "financial",
            "croissance",
            "allowAccessReview",
            financial.allowAccessReview
          )
        );
        dispatch(
          setAllowSubAccess(
            "financial",
            "dynamicTable",
            "allowAccess",
            financial.allowAccessDynamicTable
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "financial",
            "dynamicTable",
            financial.allowViewDataDynamicTableBy
          )
        );
        dispatch(
          setAllowAccess("prestations", "allowAccess", prestations.allowAccess)
        );
        dispatch(
          setAllowViewDataBy("prestations", prestations.allowViewDataBy)
        );
        dispatch(
          setAllowAccess("reporting", "allowAccess", reporting.allowAccess)
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "production",
            "allowAccess",
            reporting.allowAccessProduction
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "production",
            reporting.allowViewProductionDataBy
          )
        );
        dispatch(
          setAllowAccess(
            "reporting",
            "allowAccessCardsStatistics",
            reporting.allowAccessCardsStatistics
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "individualDevBe",
            "allowAccess",
            reporting.allowAccessIndividualDevBe
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "individualDevBe",
            reporting.allowViewIndividualDevBeDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "individualDevMa",
            "allowAccess",
            reporting.allowAccessIndividualDevMa
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "individualDevMa",
            reporting.allowViewIndividualDevMaDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "echeance",
            "allowAccess",
            reporting.allowAccessEcheance
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "echeance",
            reporting.allowViewEcheanceDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "recapBalance",
            "allowAccess",
            reporting.allowAccessRecapBalance
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "recapBalance",
            reporting.allowViewRecapBalanceDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "calendar",
            "allowAccess",
            reporting.allowAccessCalendar
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "calendar",
            reporting.allowViewCalendarDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "timesheet",
            "allowAccess",
            reporting.allowAccessTimesheet
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "timesheet",
            reporting.allowViewTimesheetDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "portfolio",
            "allowAccess",
            reporting.allowAccessPortfolio
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "portfolio",
            reporting.allowViewPortfolioDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "supervision",
            "allowAccess",
            reporting.allowAccessSupervision
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "supervision",
            reporting.allowViewSupervisionDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "vacation",
            "allowAccess",
            reporting.allowAccessVacation
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "vacation",
            reporting.allowViewVacationDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "plans",
            "allowAccess",
            reporting.allowAccessPlans
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "plans",
            reporting.allowViewPlansDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "prestations",
            "allowAccess",
            reporting.allowAccessPrestations
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "prestations",
            reporting.allowViewPrestationsDataBy
          )
        );
        dispatch(
          setAllowAccess(
            "capacityPlanning",
            "allowAccess",
            capacityPlanning.allowAccess
          )
        );
        dispatch(
          setAllowViewDataBy(
            "capacityPlanning",
            capacityPlanning.allowViewDataBy
          )
        );
        dispatch(
          setAllowAccess("settings", "allowAccess", settings.allowAccess)
        );
        dispatch(
          setAllowAccess(
            "settings",
            "allowAccessCategories",
            settings.allowAccessCategories
          )
        );
        dispatch(
          setAllowAccess(
            "settings",
            "allowAccessParameters",
            settings.allowAccessParameters
          )
        );
        dispatch(
          setAllowAccess(
            "settings",
            "allowAccessTaskTypes",
            settings.allowAccessTaskTypes
          )
        );
        dispatch(
          setAllowAccess(
            "settings",
            "allowAccessUsers",
            settings.allowAccessUsers
          )
        );
        dispatch(
          setAllowAccess(
            "settings",
            "allowAccessCalendar",
            settings.allowAccessCalendar
          )
        );
        dispatch(
          setAllowAccess(
            "settings",
            "allowAccessModels",
            settings.allowAccessModels
          )
        );
        dispatch(
          setAllowAccess(
            "settings",
            "allowAccessCollaborators",
            settings.allowAccessCollaborators
          )
        );
        dispatch(
          setAllowAccess(
            "settings",
            "allowAccessSynchronization",
            settings.allowAccessSynchronization
          )
        );
        dispatch(
          setAllowAccess("timesheet", "allowAccess", timesheet.allowAccess)
        );
        dispatch(
          setAllowAccess(
            "timesheet",
            "allowViewDataBy",
            timesheet.allowViewDataBy
          )
        );

        dispatch(setAllowUpdatingBillingView(allowUpdatingBillingView));
        dispatch(setAllowConfigurateBudget(allowConfigurateBudget));

        dispatch(setAllowUpdatingTarifClients(allowUpdatingTarifClients));
        dispatch(setAllowUpdatingNewClients(allowUpdatingNewClients));
        dispatch(setAllowUpdatingDepartClients(allowUpdatingDepartClients));

        dispatch(
          setAllowAccessToClientCollaboratorRelation(
            allowAccessToClientCollaboratorRelation
          )
        );
        dispatch(
          setAllowAccessToClientInformations(allowAccessToClientInformations)
        );
        dispatch(setAllowAccessToGlobalBudget(allowAccessToGlobalBudget));
        dispatch(setAllowUpdatingOffrePrice(allowUpdatingOffrePrice));
        dispatch(setAllowToAddDeleger(allowToAddDeleger));
        dispatch(setAllowUpdateBudgetedBenchmark(allowUpdateBudgetedBenchmark));
        dispatch(setAllowAccessToStatisticsCards(allowAccessToStatisticsCards));
        dispatch(setAllowAccessToCorrectionCards(allowAccessToCorrectionCards));
        dispatch(
          setAllowVisualizationOfBudgetedTime(allowVisualizationOfBudgetedTime)
        );
        dispatch(
          setAllowVisualizationOfBudgetedBenchmark(
            allowVisualizationOfBudgetedBenchmark
          )
        );
        dispatch(
          setAllowVisualizationOfRealizedTime(allowVisualizationOfRealizedTime)
        );
        dispatch(
          setAllowVisualizationOfRealizedBenchmark(
            allowVisualizationOfRealizedBenchmark
          )
        );

        dispatch(
          setAllowAdjustDistributionOfTasksByRole(
            allowAdjustDistributionOfTasksByRole
          )
        );
        dispatch(setAllowAttributionBU(allowAttributionBU));
        dispatch(setAllowAttributionSquad(allowAttributionSquad));
        dispatch(setAllowCollabToDevCard(allowCollabToDevCard));
        dispatch(setAllowAttributionCluster(allowAttributionCluster));
        dispatch(setAllowSelectAppliedModel(allowSelectAppliedModel));
        dispatch(setAllowTodragAndDropFromTODO(allowTodragAndDropFromTODO));
        dispatch(setAllowTodragAndDropFromWIP(allowTodragAndDropFromWIP));
        dispatch(setAllowTodragAndDropFromDONE(allowTodragAndDropFromDONE));
        dispatch(
          setAllowTodragAndDropFromVALIDATION(allowTodragAndDropFromVALIDATION)
        );

        dispatch(setAllowAccessClientSpace(allowAccessClientSpace));
        dispatch(setAllowAccessToClientList(allowAccess));
        dispatch(
          setAllowAccessToCollaboratorList(allowAccessToCollaboratorList)
        );
        dispatch(setAllowCreateCorrectionCards(allowCreateCorrectionCards));
        dispatch(setRole(roles));

        dispatch(setAllowAccessReporting(allowAccessReporting));
        dispatch(setAllowAccessReportingTab(allowAccessReportingTab));
        dispatch(setAllowAccessProductionCapacity(allowAccessProdCapacity));
        dispatch(setAllowAccessBonusPlan(allowAccessBonusPlan));
        dispatch(setAllowAccessEcheance(allowAccessEcheance));
        dispatch(setAllowAccessBalanceRecap(allowAccessBalanceRecap));
        dispatch(setAllowAccessCalendar(allowAccessCalendar));
        dispatch(setAllowAccessTimeReport(allowAccessTimeReport));
        dispatch(setAllowAccessPortfolios(allowAccessPortfolio));
        dispatch(setAllowAccessErrorReporting(allowAccessErrReporting));
        dispatch(setAllowAccessVacationMatrix(allowAccessVacationMatrix));
        dispatch(setAllowAccessPlans(allowAccessPlans));
        dispatch(setAllowAccessPrestations(allowAccessPrestation));

        dispatch(setAllowAccessPrestaTS(allowAccessPrestaTS));
        dispatch(setAllowAccessFinancial(allowAccessFinancial));
        dispatch(setAllowAccessFinancialSheet(allowAccessFinancialSheet));
        dispatch(setAllowAccessForfait(allowAccessForfait));
        dispatch(setAllowAccessCroissance(allowAccessCroissance));
        dispatch(setAllowAccessDynamicTable(allowAccessDynamicTab));
        dispatch(setAllowAccessCapacityPlanning(allowAccessCapacityPlanning));
        dispatch(
          setAllowAccessCapacityPlanningTab(allowAccessCapacityPlanningTab)
        );
        dispatch(setAllowAccessSynthesis(allowAccessSynthesis));

        dispatch(setAllowAccessCategorySetting(allowAccessSetting));
        dispatch(setAllowAccessCategorySetting(allowAccessCategorySetting));
        dispatch(setAllowAccessTaskTypeSetting(allowAccessTaskTypeSetting));
        dispatch(
          setAllowAccessCollaboratorSetting(allowAccessCollaboratorSetting)
        );
        dispatch(setAllowAccessCalendarSetting(allowAccessCalendarSetting));
        dispatch(setAllowCoefficientsConfig(allowCoefficientsConfig));
        dispatch(setAllowAccessModelSetting(allowAccessModelSetting));
        dispatch(setAllowAccessUserSetting(allowAccessUserSetting));
        dispatch(setAllowAccessSynchronization(allowAccessSynchronization));
        dispatch(setAllowAccessParameterSetting(allowAccessParameterSetting));
      } else {
        // just one selected user

        const authorisations = selectedUsers[0].accountingAuthorization;
        let withoutPreferences = !authorisations || !authorisations.preferences;

        const selectedRole = authorisations.role ? authorisations.role : "NONE";
        const allowConfigurateBudget = !(
          withoutPreferences ||
          authorisations.preferences.allowConfigurateBudget === "0"
        );
        const allowUpdatingBillingView = !(
          withoutPreferences ||
          authorisations.preferences.allowUpdatingBillingView === "0"
        );
        const allowUpdatingTarifClients = !(
          withoutPreferences ||
          authorisations.preferences.allowUpdatingTarifClients === "0"
        );
        const allowUpdatingNewClients = !(
          withoutPreferences ||
          authorisations.preferences.allowUpdatingNewClients === "0"
        );
        const allowUpdatingDepartClients = !(
          withoutPreferences ||
          authorisations.preferences.allowUpdatingDepartClients === "0"
        );
        const allowAccessToClientInformations = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessToClientInformations === "0"
        );
        const allowAccessToGlobalBudget = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessToGlobalBudget === "0"
        );
        const allowUpdatingOffrePrice = !(
          withoutPreferences ||
          authorisations.preferences.allowUpdatingOffrePrice === "0"
        );
        const allowToAddDeleger = !(
          withoutPreferences ||
          authorisations.preferences.allowToAddDeleger === "0"
        );
        const allowUpdateBudgetedBenchmark = !(
          withoutPreferences ||
          authorisations.preferences.allowUpdateBudgetedBenchmark === "0"
        );
        const allowAccessToClientCollaboratorRelation = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessToClientCollaboratorRelation ===
            "0"
        );
        const allowAccessToStatisticsCards = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessToStatisticsCards === "0"
        );
        const allowAccessToCorrectionCards = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessToCorrectionCards === "0"
        );
        const allowVisualizationOfBudgetedTime = !(
          withoutPreferences ||
          authorisations.preferences.allowVisualizationOfBudgetedTime === "0"
        );
        const allowVisualizationOfBudgetedBenchmark = !(
          withoutPreferences ||
          authorisations.preferences.allowVisualizationOfBudgetedBenchmark ===
            "0"
        );
        const allowVisualizationOfRealizedTime = !(
          withoutPreferences ||
          authorisations.preferences.allowVisualizationOfRealizedTime === "0"
        );
        const allowVisualizationOfRealizedBenchmark = !(
          withoutPreferences ||
          authorisations.preferences.allowVisualizationOfRealizedBenchmark ===
            "0"
        );

        const allowAdjustDistributionOfTasksByRole = !(
          withoutPreferences ||
          authorisations.preferences.allowAdjustDistributionOfTasksByRole ===
            "0"
        );
        const allowAttributionBU = !(
          withoutPreferences ||
          authorisations.preferences.allowAttributionBU === "0"
        );
        const allowAttributionSquad = !(
          withoutPreferences ||
          authorisations.preferences.allowAttributionSquad === "0"
        );
        const allowCollabToDevCard = !(
          withoutPreferences ||
          authorisations.preferences.allowCollabToDevCard === "0"
        );
        const allowAttributionCluster = !(
          withoutPreferences ||
          authorisations.preferences.allowAttributionCluster === "0"
        );
        const allowSelectAppliedModel = !(
          withoutPreferences ||
          authorisations.preferences.allowSelectAppliedModel === "0"
        );
        const allowTodragAndDropFromTODO = !(
          withoutPreferences ||
          authorisations.preferences.allowTodragAndDropFromTODO === "0"
        );
        const allowTodragAndDropFromWIP = !(
          withoutPreferences ||
          authorisations.preferences.allowTodragAndDropFromWIP === "0"
        );
        const allowTodragAndDropFromDONE = !(
          withoutPreferences ||
          authorisations.preferences.allowTodragAndDropFromDONE === "0"
        );
        const allowTodragAndDropFromVALIDATION = !(
          withoutPreferences ||
          authorisations.preferences.allowTodragAndDropFromVALIDATION === "0"
        );

        const allowAccess = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessToClientList === "0"
        );
        const allowAccessToCollaboratorList = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessToCollaboratorList === "0"
        );
        const allowAccessClientSpace = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessClientSpace === "0"
        );
        const allowCreateCorrectionCards = !(
          withoutPreferences ||
          authorisations.preferences.allowCreateCorrectionCards === "0"
        );
        const activateNotification = !(
          withoutPreferences ||
          authorisations.preferences.activateNotifications === "0"
        );
        const activateCarteNotification = !(
          withoutPreferences ||
          authorisations.preferences.activateCarteNotifications === "0"
        );
        const activateCalendarNotification = !(
          withoutPreferences ||
          authorisations.preferences.activateCalendarNotifications === "0"
        );

        const allowAccessReporting = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessReporting === "0"
        );
        const allowAccessReportingTab = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessReportingTab === "0"
        );
        const allowAccessProductionCapacity = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessProductionCapacity === "0"
        );
        const allowAccessBonusPlan = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessBonusPlan === "0"
        );
        const allowAccessEcheance = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessEcheance === "0"
        );
        const allowAccessBalanceRecap = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessBalanceRecap === "0"
        );
        const allowAccessCalendar = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessCalendar === "0"
        );
        const allowAccessTimeReport = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessTimeReport === "0"
        );
        const allowAccessPortfolio = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessPortfolio === "0"
        );
        const allowAccessErrReporting = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessErrReporting === "0"
        );
        const allowAccessVacationMatrix = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessVacationMatrix === "0"
        );
        const allowAccessPlans = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessPlans === "0"
        );
        const allowAccessPrestation = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessPrestation === "0"
        );

        const allowAccessPrestaTS = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessPrestaTS === "0"
        );
        const allowAccessFinancial = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessFinancial === "0"
        );
        const allowAccessFinancialSheet = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessFinancialSheet === "0"
        );
        const allowAccessForfait = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessForfait === "0"
        );
        const allowAccessCroissance = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessCroissance === "0"
        );
        const allowAccessDynamicTab = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessDynamicTab === "0"
        );
        const allowAccessCapacityPlanning = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessCapacityPlanning === "0"
        );
        const allowAccessCapacityPlanningTab = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessCapacityPlanningTab === "0"
        );
        const allowAccessSynthesis = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessSynthesis === "0"
        );

        const allowAccessSetting = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessSetting === "0"
        );
        const allowAccessCategorySetting = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessCategorySetting === "0"
        );
        const allowAccessTaskTypeSetting = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessTaskTypeSetting === "0"
        );
        const allowAccessCollaboratorSetting = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessCollaboratorSetting === "0"
        );
        const allowAccessCalendarSetting = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessCalendarSetting === "0"
        );
        const allowCoefficientsConfig = !(
          withoutPreferences ||
          authorisations.preferences.allowCoefficientsConfig === "0"
        );
        const allowAccessModelSetting = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessModelSetting === "0"
        );
        const allowAccessUserSetting = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessUserSetting === "0"
        );
        const allowAccessSynchronization = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessSynchronization === "0"
        );
        const allowAccessParameterSetting = !(
          withoutPreferences ||
          authorisations.preferences.allowAccessParameterSetting === "0"
        );

        const parsePreference = preference => {
          try {
            return typeof preference === "string"
              ? JSON.parse(preference)
              : preference || {};
          } catch (e) {
            return preference || {};
          }
        };

        const dashboardPreferences = parsePreference(
          authorisations.preferences.dashboard
        );
        const clientsPreferences = parsePreference(
          authorisations.preferences.clients
        );
        const collaboratorsPreferences = parsePreference(
          authorisations.preferences.collaborators
        );
        const financialPreferences = parsePreference(
          authorisations.preferences.financial
        );
        const prestationsPreferences = parsePreference(
          authorisations.preferences.prestations
        );
        const cpPreferences = parsePreference(
          authorisations.preferences.capacityPlanning
        );
        const settingsPreferences = parsePreference(
          authorisations.preferences.settings
        );
        const tsPreferences = parsePreference(
          authorisations.preferences.timesheet
        );
        const reportingPreferences = parsePreference(
          authorisations.preferences.reporting
        );

        const dashboard = {
          allowAccess: !(
            withoutPreferences || !dashboardPreferences.allowAccess
          )
        };

        const clients = {
          allowAccess: !(withoutPreferences || !clientsPreferences.allowAccess),
          allowViewDataBy: clientsPreferences.allowViewDataBy,
          allowUpdateBudgetConfig: !(
            withoutPreferences || !clientsPreferences.allowUpdateBudgetConfig
          ),
          allowUpdateClientSettings: !(
            withoutPreferences || !clientsPreferences.allowUpdateClientSettings
          )
        };

        const collaborators = {
          allowAccess: !(
            withoutPreferences || !collaboratorsPreferences.allowAccess
          ),
          allowConfigCollaborator: !(
            withoutPreferences ||
            !collaboratorsPreferences.allowConfigCollaborator
          ),
          allowViewDataBy: collaboratorsPreferences.allowViewDataBy,
          allowAccessCPr: !(
            withoutPreferences || !collaboratorsPreferences.allowAccessCPr
          ),
          allowAccessPlans: !(
            withoutPreferences || !collaboratorsPreferences.allowAccessPlans
          ),
          allowDragFromToDo: !(
            withoutPreferences || !collaboratorsPreferences.allowDragFromToDo
          ),
          allowDragFromWIP: !(
            withoutPreferences || !collaboratorsPreferences.allowDragFromWIP
          ),
          allowDragFromValidate: !(
            withoutPreferences ||
            !collaboratorsPreferences.allowDragFromValidate
          ),
          allowDragFromDone: !(
            withoutPreferences || !collaboratorsPreferences.allowDragFromDone
          ),
          allowAccessCalendar: !(
            withoutPreferences || !collaboratorsPreferences.allowAccessCalendar
          ),
          allowValidateVacationRequest: !(
            withoutPreferences ||
            !collaboratorsPreferences.allowValidateVacationRequest
          ),
          allowAccessPlanification: !(
            withoutPreferences ||
            !collaboratorsPreferences.allowAccessPlanification
          ),
          allowAccessFolderCapacity: !(
            withoutPreferences ||
            !collaboratorsPreferences.allowAccessFolderCapacity
          ),
          allowAccessFinancialState: !(
            withoutPreferences ||
            !collaboratorsPreferences.allowAccessFinancialState
          ),
          allowVerifyBudget: !(
            withoutPreferences || !collaboratorsPreferences.allowVerifyBudget
          )
        };

        const financial = {
          allowAccess: !(
            withoutPreferences || !financialPreferences.allowAccess
          ),
          allowAccessFinancial: !(
            withoutPreferences ||
            !(
              financialPreferences.financialState &&
              financialPreferences.financialState.allowAccess
            )
          ),
          allowViewDataFinancialBy: financialPreferences.financialState
            ? financialPreferences.financialState.allowViewDataBy
            : 0,
          allowAccessForfait: !(
            withoutPreferences ||
            !(
              financialPreferences.forfait &&
              financialPreferences.forfait.allowAccess
            )
          ),
          allowLaunchRevision: !(
            withoutPreferences ||
            !(
              financialPreferences.forfait &&
              financialPreferences.forfait.allowLaunchRevision
            )
          ),
          allowAccessCroissance: !(
            withoutPreferences ||
            !(
              financialPreferences.croissance &&
              financialPreferences.croissance.allowAccess
            )
          ),
          allowViewDataCroissanceBy: financialPreferences.croissance
            ? financialPreferences.croissance.allowViewDataBy
            : 0,
          allowAccessClientIn: !(
            withoutPreferences ||
            !(
              financialPreferences.croissance &&
              financialPreferences.croissance.allowAccessIN
            )
          ),
          allowAccessClientOut: !(
            withoutPreferences ||
            !(
              financialPreferences.croissance &&
              financialPreferences.croissance.allowAccessOUT
            )
          ),
          allowAccessRisky: !(
            withoutPreferences ||
            !(
              financialPreferences.croissance &&
              financialPreferences.croissance.allowAccessRisky
            )
          ),
          allowAccessReview: !(
            withoutPreferences ||
            !(
              financialPreferences.croissance &&
              financialPreferences.croissance.allowAccessReview
            )
          ),
          allowAccessDynamicTable: !(
            withoutPreferences ||
            !(
              financialPreferences.dynamicTable &&
              financialPreferences.dynamicTable.allowAccess
            )
          ),
          allowViewDataDynamicTableBy: financialPreferences.dynamicTable
            ? financialPreferences.dynamicTable.allowViewDataBy
            : 0
        };

        const prestations = {
          allowAccess: !(
            withoutPreferences || !prestationsPreferences.allowAccess
          ),
          allowViewDataBy: prestationsPreferences.allowViewDataBy
        };

        const reporting = {
          allowAccess: !(
            withoutPreferences || !reportingPreferences.allowAccess
          ),
          allowAccessProduction: !(
            withoutPreferences ||
            !(
              reportingPreferences.production &&
              reportingPreferences.production.allowAccess
            )
          ),
          allowViewProductionDataBy: reportingPreferences.production
            ? reportingPreferences.production.allowViewDataBy
            : 0,
          allowAccessIndividualDevBe: !(
            withoutPreferences ||
            !(
              reportingPreferences.individualDevBe &&
              reportingPreferences.individualDevBe.allowAccess
            )
          ),
          allowAccessCardsStatistics: !(
            withoutPreferences ||
            !reportingPreferences.allowAccessCardsStatistics
          ),
          allowViewIndividualDevBeDataBy: reportingPreferences.individualDevBe
            ? reportingPreferences.individualDevBe.allowViewDataBy
            : 0,
          allowAccessIndividualDevMa: !(
            withoutPreferences ||
            !(
              reportingPreferences.individualDevMa &&
              reportingPreferences.individualDevMa.allowAccess
            )
          ),
          allowViewIndividualDevMaDataBy: reportingPreferences.individualDevMa
            ? reportingPreferences.individualDevMa.allowViewDataBy
            : 0,
          allowAccessEcheance: !(
            withoutPreferences ||
            !(
              reportingPreferences.echeance &&
              reportingPreferences.echeance.allowAccess
            )
          ),
          allowViewEcheanceDataBy: reportingPreferences.echeance
            ? reportingPreferences.echeance.allowViewDataBy
            : 0,
          allowAccessRecapBalance: !(
            withoutPreferences ||
            !(
              reportingPreferences.recapBalance &&
              reportingPreferences.recapBalance.allowAccess
            )
          ),
          allowViewRecapBalanceDataBy: reportingPreferences.recapBalance
            ? reportingPreferences.recapBalance.allowViewDataBy
            : 0,
          allowAccessCalendar: !(
            withoutPreferences ||
            !(
              reportingPreferences.calendar &&
              reportingPreferences.calendar.allowAccess
            )
          ),
          allowViewCalendarDataBy: reportingPreferences.calendar
            ? reportingPreferences.calendar.allowViewDataBy
            : 0,
          allowAccessTimesheet: !(
            withoutPreferences ||
            !(
              reportingPreferences.timesheet &&
              reportingPreferences.timesheet.allowAccess
            )
          ),
          allowViewTimesheetDataBy: reportingPreferences.timesheet
            ? reportingPreferences.timesheet.allowViewDataBy
            : 0,
          allowAccessPortfolio: !(
            withoutPreferences ||
            !(
              reportingPreferences.portfolio &&
              reportingPreferences.portfolio.allowAccess
            )
          ),
          allowViewPortfolioDataBy: reportingPreferences.portfolio
            ? reportingPreferences.portfolio.allowViewDataBy
            : 0,
          allowAccessSupervision: !(
            withoutPreferences ||
            !(
              reportingPreferences.supervision &&
              reportingPreferences.supervision.allowAccess
            )
          ),
          allowViewSupervisionDataBy: reportingPreferences.supervision
            ? reportingPreferences.supervision.allowViewDataBy
            : 0,
          allowAccessVacation: !(
            withoutPreferences ||
            !(
              reportingPreferences.vacation &&
              reportingPreferences.vacation.allowAccess
            )
          ),
          allowViewVacationDataBy: reportingPreferences.vacation
            ? reportingPreferences.vacation.allowViewDataBy
            : 0,
          allowAccessPlans: !(
            withoutPreferences ||
            !(
              reportingPreferences.plans &&
              reportingPreferences.plans.allowAccess
            )
          ),
          allowViewPlansDataBy: reportingPreferences.plans
            ? reportingPreferences.plans.allowViewDataBy
            : 0,
          allowAccessPrestations: !(
            withoutPreferences ||
            !(
              reportingPreferences.prestations &&
              reportingPreferences.prestations.allowAccess
            )
          ),
          allowViewPrestationsDataBy: reportingPreferences.prestations
            ? reportingPreferences.prestations.allowViewDataBy
            : 0
        };

        const capacityPlanning = {
          allowAccess: !(withoutPreferences || !cpPreferences.allowAccess),
          allowViewDataBy: cpPreferences.allowViewDataBy
        };

        const settings = {
          allowAccess: !(
            withoutPreferences || !settingsPreferences.allowAccess
          ),
          allowAccessCategories: !(
            withoutPreferences || !settingsPreferences.allowAccessCategories
          ),
          allowAccessTaskTypes: !(
            withoutPreferences || !settingsPreferences.allowAccessTaskTypes
          ),
          allowAccessCollaborators: !(
            withoutPreferences || !settingsPreferences.allowAccessCollaborators
          ),
          allowAccessCalendar: !(
            withoutPreferences || !settingsPreferences.allowAccessCalendar
          ),
          allowAccessModels: !(
            withoutPreferences || !settingsPreferences.allowAccessModels
          ),
          allowAccessUsers: !(
            withoutPreferences || !settingsPreferences.allowAccessUsers
          ),
          allowAccessSynchronization: !(
            withoutPreferences ||
            !settingsPreferences.allowAccessSynchronization
          ),
          allowAccessParameters: !(
            withoutPreferences || !settingsPreferences.allowAccessParameters
          )
        };

        const timesheet = {
          allowAccess: !(withoutPreferences || !tsPreferences.allowAccess),
          allowViewDataBy: !tsPreferences.allowViewDataBy
        };

        dispatch(
          setAllowAccess("dashboard", "allowAccess", dashboard.allowAccess)
        );

        dispatch(setAllowAccess("clients", "allowAccess", clients.allowAccess));
        dispatch(setAllowViewDataBy("clients", clients.allowViewDataBy));
        dispatch(
          setAllowAccess(
            "clients",
            "allowUpdateBudgetConfig",
            clients.allowUpdateBudgetConfig
          )
        );
        dispatch(
          setAllowAccess(
            "clients",
            "allowUpdateClientSettings",
            clients.allowUpdateClientSettings
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowAccess",
            collaborators.allowAccess
          )
        );
        dispatch(
          setAllowViewDataBy("collaborators", collaborators.allowViewDataBy)
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowConfigCollaborator",
            collaborators.allowConfigCollaborator
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowAccessCPr",
            collaborators.allowAccessCPr
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowAccessPlans",
            collaborators.allowAccessPlans
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowDragFromToDo",
            collaborators.allowDragFromToDo
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowDragFromWIP",
            collaborators.allowDragFromWIP
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowDragFromValidate",
            collaborators.allowDragFromValidate
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowDragFromDone",
            collaborators.allowDragFromDone
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowAccessCalendar",
            collaborators.allowAccessCalendar
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowValidateVacationRequest",
            collaborators.allowValidateVacationRequest
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowAccessPlanification",
            collaborators.allowAccessPlanification
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowAccessFolderCapacity",
            collaborators.allowAccessFolderCapacity
          )
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowAccessFinancialState",
            collaborators.allowAccessFinancialState
          )
        );
        dispatch(
          setAllowAccess("financial", "allowAccess", financial.allowAccess)
        );
        dispatch(
          setAllowAccess(
            "collaborators",
            "allowVerifyBudget",
            collaborators.allowVerifyBudget
          )
        );
        dispatch(
          setAllowSubAccess(
            "financial",
            "financialState",
            "allowAccess",
            financial.allowAccessFinancial
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "financial",
            "financialState",
            financial.allowViewDataFinancialBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "financial",
            "forfait",
            "allowAccess",
            financial.allowAccessForfait
          )
        );
        dispatch(
          setAllowSubAccess(
            "financial",
            "forfait",
            "allowLaunchRevision",
            financial.allowLaunchRevision
          )
        );
        dispatch(
          setAllowSubAccess(
            "financial",
            "croissance",
            "allowAccess",
            financial.allowAccessCroissance
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "financial",
            "croissance",
            financial.allowViewDataCroissanceBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "financial",
            "croissance",
            "allowAccessIN",
            financial.allowAccessClientIn
          )
        );
        dispatch(
          setAllowSubAccess(
            "financial",
            "croissance",
            "allowAccessOUT",
            financial.allowAccessClientOut
          )
        );
        dispatch(
          setAllowSubAccess(
            "financial",
            "croissance",
            "allowAccessRisky",
            financial.allowAccessRisky
          )
        );
        dispatch(
          setAllowSubAccess(
            "financial",
            "croissance",
            "allowAccessReview",
            financial.allowAccessReview
          )
        );
        dispatch(
          setAllowSubAccess(
            "financial",
            "dynamicTable",
            "allowAccess",
            financial.allowAccessDynamicTable
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "financial",
            "dynamicTable",
            financial.allowViewDataDynamicTableBy
          )
        );
        dispatch(
          setAllowAccess("prestations", "allowAccess", prestations.allowAccess)
        );
        dispatch(
          setAllowViewDataBy("prestations", prestations.allowViewDataBy)
        );
        dispatch(
          setAllowAccess("reporting", "allowAccess", reporting.allowAccess)
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "production",
            "allowAccess",
            reporting.allowAccessProduction
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "production",
            reporting.allowViewProductionDataBy
          )
        );
        dispatch(
          setAllowAccess(
            "reporting",
            "allowAccessCardsStatistics",
            reporting.allowAccessCardsStatistics
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "individualDevBe",
            "allowAccess",
            reporting.allowAccessIndividualDevBe
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "individualDevBe",
            reporting.allowViewIndividualDevBeDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "individualDevMa",
            "allowAccess",
            reporting.allowAccessIndividualDevMa
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "individualDevMa",
            reporting.allowViewIndividualDevMaDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "echeance",
            "allowAccess",
            reporting.allowAccessEcheance
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "echeance",
            reporting.allowViewEcheanceDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "recapBalance",
            "allowAccess",
            reporting.allowAccessRecapBalance
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "recapBalance",
            reporting.allowViewRecapBalanceDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "calendar",
            "allowAccess",
            reporting.allowAccessCalendar
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "calendar",
            reporting.allowViewCalendarDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "timesheet",
            "allowAccess",
            reporting.allowAccessTimesheet
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "timesheet",
            reporting.allowViewTimesheetDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "portfolio",
            "allowAccess",
            reporting.allowAccessPortfolio
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "portfolio",
            reporting.allowViewPortfolioDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "supervision",
            "allowAccess",
            reporting.allowAccessSupervision
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "supervision",
            reporting.allowViewSupervisionDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "vacation",
            "allowAccess",
            reporting.allowAccessVacation
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "vacation",
            reporting.allowViewVacationDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "plans",
            "allowAccess",
            reporting.allowAccessPlans
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "plans",
            reporting.allowViewPlansDataBy
          )
        );
        dispatch(
          setAllowSubAccess(
            "reporting",
            "prestations",
            "allowAccess",
            reporting.allowAccessPrestations
          )
        );
        dispatch(
          setAllowViewSubDataBy(
            "reporting",
            "prestations",
            reporting.allowViewPrestationsDataBy
          )
        );
        dispatch(
          setAllowAccess(
            "capacityPlanning",
            "allowAccess",
            capacityPlanning.allowAccess
          )
        );
        dispatch(
          setAllowViewDataBy(
            "capacityPlanning",
            capacityPlanning.allowViewDataBy
          )
        );
        dispatch(
          setAllowAccess("settings", "allowAccess", settings.allowAccess)
        );
        dispatch(
          setAllowAccess(
            "settings",
            "allowAccessCategories",
            settings.allowAccessCategories
          )
        );
        dispatch(
          setAllowAccess(
            "settings",
            "allowAccessTaskTypes",
            settings.allowAccessTaskTypes
          )
        );
        dispatch(
          setAllowAccess(
            "settings",
            "allowAccessCollaborators",
            settings.allowAccessCollaborators
          )
        );
        dispatch(
          setAllowAccess(
            "settings",
            "allowAccessCalendar",
            settings.allowAccessCalendar
          )
        );
        dispatch(
          setAllowAccess(
            "settings",
            "allowAccessModels",
            settings.allowAccessModels
          )
        );
        dispatch(
          setAllowAccess(
            "settings",
            "allowAccessUsers",
            settings.allowAccessUsers
          )
        );
        dispatch(
          setAllowAccess(
            "settings",
            "allowAccessSynchronization",
            settings.allowAccessSynchronization
          )
        );
        dispatch(
          setAllowAccess(
            "settings",
            "allowAccessParameters",
            settings.allowAccessParameters
          )
        );
        dispatch(
          setAllowAccess("timesheet", "allowAccess", timesheet.allowAccess)
        );
        dispatch(setAllowViewDataBy("timesheet", timesheet.allowViewDataBy));

        dispatch(setActivateNotifications(activateNotification));
        dispatch(setActivateCarteNotifications(activateCarteNotification));
        dispatch(
          setActivateCalendarNotifications(activateCalendarNotification)
        );
        dispatch(setAllowConfigurateBudget(allowConfigurateBudget));
        dispatch(setAllowUpdatingBillingView(allowUpdatingBillingView));
        dispatch(setAllowUpdatingTarifClients(allowUpdatingTarifClients));
        dispatch(setAllowUpdatingNewClients(allowUpdatingNewClients));
        dispatch(setAllowUpdatingDepartClients(allowUpdatingDepartClients));
        dispatch(
          setAllowAccessToClientCollaboratorRelation(
            allowAccessToClientCollaboratorRelation
          )
        );
        dispatch(setAllowUpdateBudgetedBenchmark(allowUpdateBudgetedBenchmark));
        dispatch(setAllowToAddDeleger(allowToAddDeleger));
        dispatch(setAllowUpdatingOffrePrice(allowUpdatingOffrePrice));
        dispatch(setAllowAccessToGlobalBudget(allowAccessToGlobalBudget));
        dispatch(
          setAllowAccessToClientInformations(allowAccessToClientInformations)
        );
        dispatch(setAllowAccessToStatisticsCards(allowAccessToStatisticsCards));
        dispatch(setAllowAccessToCorrectionCards(allowAccessToCorrectionCards));
        dispatch(
          setAllowVisualizationOfBudgetedTime(allowVisualizationOfBudgetedTime)
        );
        dispatch(
          setAllowVisualizationOfBudgetedBenchmark(
            allowVisualizationOfBudgetedBenchmark
          )
        );
        dispatch(
          setAllowVisualizationOfRealizedTime(allowVisualizationOfRealizedTime)
        );
        dispatch(
          setAllowVisualizationOfRealizedBenchmark(
            allowVisualizationOfRealizedBenchmark
          )
        );

        dispatch(
          setAllowAdjustDistributionOfTasksByRole(
            allowAdjustDistributionOfTasksByRole
          )
        );
        dispatch(setAllowAttributionBU(allowAttributionBU));
        dispatch(setAllowAttributionSquad(allowAttributionSquad));
        dispatch(setAllowCollabToDevCard(allowCollabToDevCard));
        dispatch(setAllowAttributionCluster(allowAttributionCluster));
        dispatch(setAllowSelectAppliedModel(allowSelectAppliedModel));
        dispatch(setAllowTodragAndDropFromTODO(allowTodragAndDropFromTODO));
        dispatch(setAllowTodragAndDropFromWIP(allowTodragAndDropFromWIP));
        dispatch(setAllowTodragAndDropFromDONE(allowTodragAndDropFromDONE));
        dispatch(
          setAllowTodragAndDropFromVALIDATION(allowTodragAndDropFromVALIDATION)
        );

        dispatch(setAllowAccessClientSpace(allowAccessClientSpace));
        dispatch(setAllowAccessToClientList(allowAccess));
        dispatch(
          setAllowAccessToCollaboratorList(allowAccessToCollaboratorList)
        );
        dispatch(setAllowCreateCorrectionCards(allowCreateCorrectionCards));
        dispatch(setRole(selectedRole));

        dispatch(setAllowAccessReporting(allowAccessReporting));
        dispatch(setAllowAccessReportingTab(allowAccessReportingTab));
        dispatch(
          setAllowAccessProductionCapacity(allowAccessProductionCapacity)
        );
        dispatch(setAllowAccessBonusPlan(allowAccessBonusPlan));
        dispatch(setAllowAccessEcheance(allowAccessEcheance));
        dispatch(setAllowAccessBalanceRecap(allowAccessBalanceRecap));
        dispatch(setAllowAccessCalendar(allowAccessCalendar));
        dispatch(setAllowAccessTimeReport(allowAccessTimeReport));
        dispatch(setAllowAccessPortfolios(allowAccessPortfolio));
        dispatch(setAllowAccessErrorReporting(allowAccessErrReporting));
        dispatch(setAllowAccessVacationMatrix(allowAccessVacationMatrix));
        dispatch(setAllowAccessPlans(allowAccessPlans));
        dispatch(setAllowAccessPrestations(allowAccessPrestation));

        dispatch(setAllowAccessPrestaTS(allowAccessPrestaTS));
        dispatch(setAllowAccessFinancial(allowAccessFinancial));
        dispatch(setAllowAccessFinancialSheet(allowAccessFinancialSheet));
        dispatch(setAllowAccessForfait(allowAccessForfait));
        dispatch(setAllowAccessCroissance(allowAccessCroissance));
        dispatch(setAllowAccessDynamicTable(allowAccessDynamicTab));
        dispatch(setAllowAccessCapacityPlanning(allowAccessCapacityPlanning));
        dispatch(
          setAllowAccessCapacityPlanningTab(allowAccessCapacityPlanningTab)
        );
        dispatch(setAllowAccessSynthesis(allowAccessSynthesis));

        dispatch(setAllowAccessSetting(allowAccessSetting));
        dispatch(setAllowAccessCategorySetting(allowAccessCategorySetting));
        dispatch(setAllowAccessTaskTypeSetting(allowAccessTaskTypeSetting));
        dispatch(
          setAllowAccessCollaboratorSetting(allowAccessCollaboratorSetting)
        );
        dispatch(setAllowAccessCalendarSetting(allowAccessCalendarSetting));
        dispatch(setAllowCoefficientsConfig(allowCoefficientsConfig));
        dispatch(setAllowAccessModelSetting(allowAccessModelSetting));
        dispatch(setAllowAccessUserSetting(allowAccessUserSetting));
        dispatch(setAllowAccessSynchronization(allowAccessSynchronization));
        dispatch(setAllowAccessParameterSetting(allowAccessParameterSetting));
      }
    }
  }

  init() {
    this.props.dispatch(initSaveUsers());
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.add("hide");
    this.props.dispatch(setSelectedUsers([]));
    this.props.handleSettingsTab(false);
  }

  handleCancel = () => {
    this.props.handleSettingsTab(false);
    this.props.dispatch(setSelectedUsers([]));
    // if (typeof onCancel === "function") {
    //   onCancel();
    // }

    // new style
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.add("hide");

    //  if (!inIframe()) {
    //    document.getElementById("mainMenu").style.zIndex = 4;
    //  }
    document.body.classList.remove("hidden_overflow");
  };

  saveUsersSettings() {
    this.props.dispatch(updateUsersSettings()).then(res => {
      this.props.dispatch(fetchUsers());
      this.handleCancel();
    }, err => err);
  }

  renderSingleUser(user) {
    const {
      firstName,
      lastName,
      avatar,
      avatarUrl,
      role,
      accountingAuthorization
    } = user;

    let avatarDiv = null;
    if (avatarUrl !== undefined) {
      avatarDiv = (
        <div
          className={styles.user_avatar}
          style={{ backgroundImage: `url(${avatarUrl})` }}
        />
      );
    } else if (avatar) {
      avatarDiv = (
        <div
          className={styles.user_avatar}
          style={{ backgroundImage: `url(${TTP_API_URL}/${avatar})` }}
        />
      );
    } else {
      avatarDiv = (
        <div className={classnames(styles.user_avatar, "empty-avatar")}>
          <span>{getUserNameForAvatar(firstName, lastName)}</span>
        </div>
      );
    }

    let signatureDiv = [];
    signatureDiv.push(<h3 key="sh3">{firstName + " " + lastName}</h3>);
    if (role && role.id !== undefined) {
      signatureDiv.push(<h4 key="sh4">{_(role.type)}</h4>);
    }
    signatureDiv.push(
      <h5 key="h5">
        {/*@todo to delete this dump test for translation purpose */}
        {accountingAuthorization && accountingAuthorization.role !== undefined
          ? accountingAuthorization.role === "MANAGER"
            ? _("partner")
            : _(accountingAuthorization.role)
          : "____"}
      </h5>
    );
    return (
      <div className={classnames(styles.user, styles.sidebar__user)}>
        {avatarDiv}
        <div className={styles.user_header}>{signatureDiv}</div>
      </div>
    );
  }

  renderGroupUsers(users) {
    let avatarsDiv = [];
    let names = [];

    for (let i = 0; i < users.length; i++) {
      if (i >= 3) {
        break;
      }
      let { id, firstName, lastName, avatar, avatarUrl } = users[i];

      names.push(users.length <= 3 ? firstName + " " + lastName : firstName);
      if (avatarUrl) {
        avatarsDiv.push(
          <div
            key={`user-${id}`}
            className={styles.user_avatar}
            style={{ backgroundImage: `url(${avatarUrl})` }}
          />
        );
      } else if (avatar) {
        avatarsDiv.push(
          <div
            key={`user-${id}`}
            className={styles.user_avatar}
            style={{ backgroundImage: `url(${TTP_API_URL}/${avatar})` }}
          />
        );
      } else {
        avatarsDiv.push(
          <div
            key={`user-${id}`}
            className={classnames(styles.user_avatar, "empty-avatar")}
          >
            <span>{getUserNameForAvatar(firstName, lastName)}</span>
          </div>
        );
      }
    }
    let other = 0;
    if (users.length > 3) {
      other = users.length - 3;
    }
    return (
      <div className={styles.side__bar_group}>
        <div className={styles.side__bar_group_avatar}>{avatarsDiv}</div>
        <div className={styles.side__bar_group_names}>
          {names.join(users.length <= 3 ? _(" and ") : ", ")}
          {other > 0 ? (
            <span>
              {" "}
              {_(" and ")}{" "}
              <strong>
                {other} {_("Other user(s)")}.
              </strong>
            </span>
          ) : null}
        </div>
      </div>
    );
  }

  renderUsers() {
    const { selectedUsers } = this.props;

    if (!selectedUsers || selectedUsers.length === 0) {
      return null;
    }

    if (selectedUsers.length === 1) {
      return this.renderSingleUser(selectedUsers[0]);
    } else {
      return this.renderGroupUsers(selectedUsers);
    }
  }

  setRoleValue(val) {
    const {
      dispatch,
      parameterSettings: {
        data: { defaultAuthParameters }
      }
    } = this.props;
    dispatch(setRole(val));
    if (val == "MANAGER") {
      dispatch(setDefaultAuthParameters(defaultAuthParameters["partner"]));
    } else {
      dispatch(
        setDefaultAuthParameters(defaultAuthParameters[val.toLowerCase()])
      );
    }
  }

  setAllowConfigurateBudget(allowCreation) {
    this.props.dispatch(setAllowConfigurateBudget(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowUpdatingBillingView(allowCreation) {
    this.props.dispatch(setAllowUpdatingBillingView(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowUpdatingTarifClients(allowCreation) {
    this.props.dispatch(setAllowUpdatingTarifClients(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowUpdatingNewClients(allowCreation) {
    this.props.dispatch(setAllowUpdatingNewClients(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowUpdatingDepartClients(allowCreation) {
    this.props.dispatch(setAllowUpdatingDepartClients(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }

  setAllowAccessToClientCollaboratorRelation(allowCreation) {
    this.props.dispatch(
      setAllowAccessToClientCollaboratorRelation(allowCreation)
    );
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowUpdateBudgetedBenchmark(allowCreation) {
    this.props.dispatch(setAllowUpdateBudgetedBenchmark(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowToAddDeleger(allowCreation) {
    this.props.dispatch(setAllowToAddDeleger(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowUpdatingOffrePrice(allowCreation) {
    this.props.dispatch(setAllowUpdatingOffrePrice(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowAccessToGlobalBudget(allowCreation) {
    this.props.dispatch(setAllowAccessToGlobalBudget(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowAccessToClientInformations(allowCreation) {
    this.props.dispatch(setAllowAccessToClientInformations(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowAccessToStatisticsCards(allowCreation) {
    this.props.dispatch(setAllowAccessToStatisticsCards(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowAccessToCorrectionCards(allowCreation) {
    this.props.dispatch(setAllowAccessToCorrectionCards(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowVisualizationOfBudgetedTime(allowCreation) {
    this.props.dispatch(setAllowVisualizationOfBudgetedTime(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowVisualizationOfBudgetedBenchmark(allowCreation) {
    this.props.dispatch(
      setAllowVisualizationOfBudgetedBenchmark(allowCreation)
    );
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowVisualizationOfRealizedTime(allowCreation) {
    this.props.dispatch(setAllowVisualizationOfRealizedTime(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowVisualizationOfRealizedBenchmark(allowCreation) {
    this.props.dispatch(
      setAllowVisualizationOfRealizedBenchmark(allowCreation)
    );
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }

  setAllowAdjustDistributionOfTasksByRole(allowCreation) {
    this.props.dispatch(setAllowAdjustDistributionOfTasksByRole(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowAttributionBU(allowCreation) {
    this.props.dispatch(setAllowAttributionBU(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowAttributionSquad(allowCreation) {
    this.props.dispatch(setAllowAttributionSquad(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowCollabToDevCard(allowCreation) {
    this.props.dispatch(setAllowCollabToDevCard(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowAttributionCluster(allowCreation) {
    this.props.dispatch(setAllowAttributionCluster(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowSelectAppliedModel(allowCreation) {
    this.props.dispatch(setAllowSelectAppliedModel(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowTodragAndDropFromTODO(allowCreation) {
    this.props.dispatch(setAllowTodragAndDropFromTODO(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowTodragAndDropFromWIP(allowCreation) {
    this.props.dispatch(setAllowTodragAndDropFromWIP(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowTodragAndDropFromDONE(allowCreation) {
    this.props.dispatch(setAllowTodragAndDropFromDONE(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }
  setAllowTodragAndDropFromVALIDATION(allowCreation) {
    this.props.dispatch(setAllowTodragAndDropFromVALIDATION(allowCreation));
    allowCreation &&
      this.props.dispatch(setAllowAccessToClientList(allowCreation));
  }

  setAllowAccessClientSpace(allowAccess) {
    this.props.dispatch(setAllowAccessClientSpace(allowAccess));
    allowAccess && this.props.dispatch(setAllowAccessToClientList(allowAccess));
  }

  setAllowAccessToClientList(allowAccess) {
    this.props.dispatch(setAllowAccessToClientList(allowAccess));
    !allowAccess && this.props.dispatch(setAllowConfigurateBudget(allowAccess));
    !allowAccess &&
      this.props.dispatch(setAllowUpdatingBillingView(allowAccess));
    !allowAccess &&
      this.props.dispatch(setAllowUpdatingTarifClients(allowAccess));
    !allowAccess &&
      this.props.dispatch(setAllowUpdatingNewClients(allowAccess));
    !allowAccess &&
      this.props.dispatch(setAllowUpdatingDepartClients(allowAccess));
    !allowAccess &&
      this.props.dispatch(
        setAllowAccessToClientCollaboratorRelation(allowAccess)
      );
    !allowAccess &&
      this.props.dispatch(setAllowAccessToClientInformations(allowAccess));
    !allowAccess &&
      this.props.dispatch(setAllowAccessToGlobalBudget(allowAccess));
    !allowAccess &&
      this.props.dispatch(setAllowUpdatingOffrePrice(allowAccess));
    !allowAccess && this.props.dispatch(setAllowToAddDeleger(allowAccess));
    !allowAccess &&
      this.props.dispatch(setAllowUpdateBudgetedBenchmark(allowAccess));
    !allowAccess &&
      this.props.dispatch(setAllowAccessToStatisticsCards(allowAccess));
    !allowAccess &&
      this.props.dispatch(setAllowAccessToCorrectionCards(allowAccess));
    !allowAccess &&
      this.props.dispatch(setAllowVisualizationOfBudgetedTime(allowAccess));
    !allowAccess &&
      this.props.dispatch(
        setAllowVisualizationOfBudgetedBenchmark(allowAccess)
      );
    !allowAccess &&
      this.props.dispatch(setAllowVisualizationOfRealizedTime(allowAccess));
    !allowAccess &&
      this.props.dispatch(
        setAllowVisualizationOfRealizedBenchmark(allowAccess)
      );

    !allowAccess &&
      this.props.dispatch(setAllowAdjustDistributionOfTasksByRole(allowAccess));
    !allowAccess && this.props.dispatch(setAllowAttributionBU(allowAccess));
    !allowAccess && this.props.dispatch(setAllowAttributionSquad(allowAccess));
    !allowAccess && this.props.dispatch(setAllowCollabToDevCard(allowAccess));
    !allowAccess &&
      this.props.dispatch(setAllowAttributionCluster(allowAccess));
    !allowAccess &&
      this.props.dispatch(setAllowSelectAppliedModel(allowAccess));
    !allowAccess &&
      this.props.dispatch(setAllowTodragAndDropFromTODO(allowAccess));
    !allowAccess &&
      this.props.dispatch(setAllowTodragAndDropFromWIP(allowAccess));
    !allowAccess &&
      this.props.dispatch(setAllowTodragAndDropFromDONE(allowAccess));
    !allowAccess &&
      this.props.dispatch(setAllowTodragAndDropFromVALIDATION(allowAccess));

    !allowAccess &&
      this.props.dispatch(setAllowCreateCorrectionCards(allowAccess));
    !allowAccess && this.props.dispatch(setAllowAccessClientSpace(allowAccess));
  }

  setAllowCreateCorrectionCards(allowAssociate) {
    this.props.dispatch(setAllowCreateCorrectionCards(allowAssociate));
    allowAssociate &&
      this.props.dispatch(setAllowAccessToClientList(allowAssociate));
  }

  setAllowAccessToCollaboratorList(allowAssociate) {
    this.props.dispatch(setAllowAccessToCollaboratorList(allowAssociate));
  }

  setActivateNotifications(activate) {
    this.props.dispatch(setActivateNotifications(activate));
    this.props.dispatch(setActivateCarteNotifications(activate));
    this.props.dispatch(setActivateCalendarNotifications(activate));
  }

  setActivateCarteNotifications(activate) {
    const { activateCalendarNotifications } = this.props;
    this.props.dispatch(
      setActivateNotifications(activate && activateCalendarNotifications)
    );
    this.props.dispatch(setActivateCarteNotifications(activate));
  }

  setActivateCalendarNotifications(activate) {
    const { activateCarteNotifications } = this.props;
    this.props.dispatch(
      setActivateNotifications(activate && activateCarteNotifications)
    );
    this.props.dispatch(setActivateCalendarNotifications(activate));
  }

  setAllowAccessReporting = allowReporting => {
    const { dispatch } = this.props;
    dispatch(setAllowAccessReporting(allowReporting));
    dispatch(setAllowAccessReportingTab(allowReporting));
    if (!allowReporting) {
      dispatch(setAllowAccessReportingTab(false));
      dispatch(setAllowAccessProductionCapacity(false));
      dispatch(setAllowAccessBonusPlan(false));
      dispatch(setAllowAccessEcheance(false));
      dispatch(setAllowAccessBalanceRecap(false));
      dispatch(setAllowAccessCalendar(false));
      dispatch(setAllowAccessTimeReport(false));
      dispatch(setAllowAccessPortfolios(false));
      dispatch(setAllowAccessErrorReporting(false));
      dispatch(setAllowAccessVacationMatrix(false));
      dispatch(setAllowAccessPlans(false));
      dispatch(setAllowAccessPrestations(false));
    }
  };

  setAllowAccessReportingTab(allowReporting) {
    this.props.dispatch(setAllowAccessReportingTab(allowReporting));
    allowReporting &&
      this.props.dispatch(setAllowAccessReporting(allowReporting));
  }

  setAllowAccessProductionCapacity(allowReporting) {
    this.props.dispatch(setAllowAccessProductionCapacity(allowReporting));
    allowReporting &&
      this.props.dispatch(setAllowAccessReporting(allowReporting));
  }

  setAllowAccessBonusPlan(allowReporting) {
    this.props.dispatch(setAllowAccessBonusPlan(allowReporting));
    allowReporting &&
      this.props.dispatch(setAllowAccessReporting(allowReporting));
  }

  setAllowAccessEcheance(allowReporting) {
    this.props.dispatch(setAllowAccessEcheance(allowReporting));
    allowReporting &&
      this.props.dispatch(setAllowAccessReporting(allowReporting));
  }

  setAllowAccessBalanceRecap(allowReporting) {
    this.props.dispatch(setAllowAccessBalanceRecap(allowReporting));
    allowReporting &&
      this.props.dispatch(setAllowAccessReporting(allowReporting));
  }

  setAllowAccessCalendar(allowReporting) {
    this.props.dispatch(setAllowAccessCalendar(allowReporting));
    allowReporting &&
      this.props.dispatch(setAllowAccessReporting(allowReporting));
  }

  setAllowAccessTimeReport(allowReporting) {
    this.props.dispatch(setAllowAccessTimeReport(allowReporting));
    allowReporting &&
      this.props.dispatch(setAllowAccessReporting(allowReporting));
  }

  setAllowAccessPortfolios(allowReporting) {
    this.props.dispatch(setAllowAccessPortfolios(allowReporting));
    allowReporting &&
      this.props.dispatch(setAllowAccessReporting(allowReporting));
  }

  setAllowAccessErrorReporting(allowReporting) {
    this.props.dispatch(setAllowAccessErrorReporting(allowReporting));
    allowReporting &&
      this.props.dispatch(setAllowAccessReporting(allowReporting));
  }

  setAllowAccessVacationMatrix(allowReporting) {
    this.props.dispatch(setAllowAccessVacationMatrix(allowReporting));
    allowReporting &&
      this.props.dispatch(setAllowAccessReporting(allowReporting));
  }

  setAllowAccessPlans(allowReporting) {
    this.props.dispatch(setAllowAccessPlans(allowReporting));
    allowReporting &&
      this.props.dispatch(setAllowAccessReporting(allowReporting));
  }

  setAllowAccessPrestations(allowReporting) {
    this.props.dispatch(setAllowAccessPrestations(allowReporting));
    allowReporting &&
      this.props.dispatch(setAllowAccessReporting(allowReporting));
  }

  setAllowAccessPrestaTS(allowPrestaTS) {
    this.props.dispatch(setAllowAccessPrestaTS(allowPrestaTS));
  }

  setAllowAccessFinancial(allowFinancial) {
    this.props.dispatch(setAllowAccessFinancial(allowFinancial));
    this.props.dispatch(setAllowAccessFinancialSheet(allowFinancial));
    !allowFinancial &&
      this.props.dispatch(setAllowAccessFinancialSheet(allowFinancial));
    !allowFinancial &&
      this.props.dispatch(setAllowAccessForfait(allowFinancial));
    !allowFinancial &&
      this.props.dispatch(setAllowAccessCroissance(allowFinancial));
  }

  setAllowAccessFinancialSheet(allowReporting) {
    this.props.dispatch(setAllowAccessFinancialSheet(allowReporting));
    allowReporting &&
      this.props.dispatch(setAllowAccessFinancial(allowReporting));
  }

  setAllowAccessForfait(allowFinancial) {
    this.props.dispatch(setAllowAccessForfait(allowFinancial));
    allowFinancial &&
      this.props.dispatch(setAllowAccessFinancial(allowFinancial));
  }

  setAllowAccessCroissance(allowFinancial) {
    this.props.dispatch(setAllowAccessCroissance(allowFinancial));
    allowFinancial &&
      this.props.dispatch(setAllowAccessFinancial(allowFinancial));
  }

  setAllowAccessDynamicTable(allowDynamicTab) {
    this.props.dispatch(setAllowAccessDynamicTable(allowDynamicTab));
  }

  setAllowAccessCapacityPlanning(allowCapPlan) {
    this.props.dispatch(setAllowAccessCapacityPlanning(allowCapPlan));
    this.props.dispatch(setAllowAccessCapacityPlanningTab(allowCapPlan));
    !allowCapPlan &&
      this.props.dispatch(setAllowAccessCapacityPlanningTab(allowCapPlan));
    !allowCapPlan && this.props.dispatch(setAllowAccessSynthesis(allowCapPlan));
  }

  setAllowAccessCapacityPlanningTab(allowCapPlan) {
    this.props.dispatch(setAllowAccessCapacityPlanningTab(allowCapPlan));
    allowCapPlan &&
      this.props.dispatch(setAllowAccessCapacityPlanning(allowCapPlan));
  }

  setAllowAccessSyncthesis(allowCapPlan) {
    this.props.dispatch(setAllowAccessSynthesis(allowCapPlan));
    allowCapPlan &&
      this.props.dispatch(setAllowAccessCapacityPlanning(allowCapPlan));
  }

  setAllowAccessSetting = allowSetting => {
    const { dispatch } = this.props;
    dispatch(setAllowAccessSetting(allowSetting));
    dispatch(setAllowAccessUserSetting(allowSetting));
    if (!allowSetting) {
      dispatch(setAllowAccessCategorySetting(false));
      dispatch(setAllowAccessTaskTypeSetting(false));
      dispatch(setAllowAccessCollaboratorSetting(false));
      dispatch(setAllowAccessCalendarSetting(false));
      dispatch(setAllowCoefficientsConfig(false));
      dispatch(setAllowAccessModelSetting(false));
      dispatch(setAllowAccessParameterSetting(false));
      dispatch(setAllowAccessUserSetting(false));
      dispatch(setAllowAccessSynchronization(false));
    }
  };

  setAllowAccessCategorySetting(allowSetting) {
    this.props.dispatch(setAllowAccessCategorySetting(allowSetting));
    allowSetting && this.props.dispatch(setAllowAccessSetting(allowSetting));
  }

  setAllowAccessTaskTypeSetting(allowSetting) {
    this.props.dispatch(setAllowAccessTaskTypeSetting(allowSetting));
    allowSetting && this.props.dispatch(setAllowAccessSetting(allowSetting));
  }

  setAllowAccessCollaboratorSetting(allowSetting) {
    this.props.dispatch(setAllowAccessCollaboratorSetting(allowSetting));
    allowSetting && this.props.dispatch(setAllowAccessSetting(allowSetting));
  }

  setAllowAccessCalendarSetting(allowSetting) {
    this.props.dispatch(setAllowAccessCalendarSetting(allowSetting));
    allowSetting && this.props.dispatch(setAllowAccessSetting(allowSetting));
  }

  setAllowCoefficientsConfig(allowSetting) {
    this.props.dispatch(setAllowCoefficientsConfig(allowSetting));
    allowSetting && this.props.dispatch(setAllowAccessSetting(allowSetting));
  }

  setAllowAccessModelSetting(allowSetting) {
    this.props.dispatch(setAllowAccessModelSetting(allowSetting));
    allowSetting && this.props.dispatch(setAllowAccessSetting(allowSetting));
  }

  setAllowAccessUserSetting(allowSetting) {
    this.props.dispatch(setAllowAccessUserSetting(allowSetting));
    allowSetting && this.props.dispatch(setAllowAccessSetting(allowSetting));
  }

  setAllowAccessSynchronization(allowSetting) {
    this.props.dispatch(setAllowAccessSynchronization(allowSetting));
    allowSetting && this.props.dispatch(setAllowAccessSetting(allowSetting));
  }

  setAllowAccessParameterSetting(allowSetting) {
    this.props.dispatch(setAllowAccessParameterSetting(allowSetting));
    allowSetting && this.props.dispatch(setAllowAccessSetting(allowSetting));
  }

  setAllowAccess(page, key, allowAccess) {
    if (allowAccess)
      this.props.dispatch(setAllowAccess(page, key, allowAccess));
    else this.props.dispatch(resetAllowAccess(page));
  }
  setAllowSubAccess(page, subPage, key, allowAccess) {
    if (allowAccess)
      this.props.dispatch(setAllowSubAccess(page, subPage, key, allowAccess));
    else this.props.dispatch(resetAllowSubAccess(page, subPage));
  }
  handleSwitch(page, key, allowAccess) {
    this.props.dispatch(setAllowAccess(page, key, allowAccess));
  }
  handleSubSwitch(page, subPage, key, allowAccess) {
    this.props.dispatch(setAllowSubAccess(page, subPage, key, allowAccess));
  }
  setAllowViewDataBy(page, allowViewData) {
    this.props.dispatch(setAllowViewDataBy(page, allowViewData));
  }
  setAllowViewSubDataBy(page, subPage, allowViewData) {
    this.props.dispatch(setAllowViewSubDataBy(page, subPage, allowViewData));
  }

  // Parent pages
  handleSwitchToggle(page) {
    this.props.dispatch(toggleViewDataBy(page));
  }
  handleOptionChange(page, event) {
    this.props.dispatch(setAllowViewDataBy(page, event.target.value));
  }

  // Sub pages
  handleSubSwitchToggle(page, subPage) {
    this.props.dispatch(toggleViewSubDataBy(page, subPage));
  }

  handleSubRadioToggle(page, subPage) {
    this.props.dispatch(toggleViewDataListBy(page, subPage));
  }

  handleSubOptionChange(page, subPage, event) {
    this.props.dispatch(
      setAllowViewSubDataBy(page, subPage, event.target.value)
    );
  }

  handleSubOptionChangeRadio(page, subPage, event) {
    this.props.dispatch(setAllowViewSubDataListBy(page, subPage, event));
  }

  renderViewDataBySwitch(title, page, viewDataBy) {
    return (
      <div>
        <div className={"switch"}>
          <span className="sidebar_role">{_(title)}</span>
          <Switch
            name="allowViewDataBy"
            keyAttr="sms-create"
            isChecked={viewDataBy !== 0}
            onChange={val => this.handleSwitchToggle(page)}
          />
        </div>
        {viewDataBy != 0 ? (
          <Radio.Group
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: 15,
              marginLeft: 80
            }}
            onChange={event => this.handleOptionChange(page, event)}
            value={viewDataBy}
            options={[
              {
                value: 1,
                label: _("all")
              },
              {
                value: 10,
                label: _("personal")
              },
              {
                value: 11,
                label: _("partnership")
              },
              {
                value: 100,
                label: _("BU")
              },
              {
                value: 101,
                label: _("zone")
              },
              {
                value: 110,
                label: _("backup")
              }
            ]}
          />
        ) : null}
      </div>
    );
  }

  renderViewSubDataBySwitch(title, page, subPage, viewDataBy) {
    return (
      <div>
        <div className={"switch"}>
          <span className="sidebar_role">{_(title)}</span>
          <Switch
            name="allowViewDataBy"
            keyAttr="sms-create"
            isChecked={viewDataBy !== 0}
            onChange={val => this.handleSubSwitchToggle(page, subPage)}
          />
        </div>
        {viewDataBy != 0 ? (
          <Radio.Group
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: 15,
              marginLeft: 80
            }}
            onChange={event => this.handleSubOptionChange(page, subPage, event)}
            value={viewDataBy}
            options={[
              {
                value: 1,
                label: _("all")
              },
              {
                value: 10,
                label: _("personal")
              },
              {
                value: 11,
                label: _("partnership")
              },
              {
                value: 100,
                label: _("BU")
              },
              {
                value: 101,
                label: _("zone")
              },
              {
                value: 110,
                label: _("backup")
              }
            ]}
          />
        ) : null}
      </div>
    );
  }

  renderViewSubDataByRadio(title, page, subPage, viewDataBy) {
    return (
      <div>
        <div className={"switch"}>
          <span className="sidebar_role">{_(title)}</span>
          <Switch
            name="allowViewDataBy"
            keyAttr="sms-create"
            isChecked={viewDataBy.length}
            onChange={val => this.handleSubRadioToggle(page, subPage)}
          />
        </div>
        {viewDataBy.length > 0 ? (
          <Checkbox.Group
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: 15,
              marginLeft: 80
            }}
            onChange={event =>
              this.handleSubOptionChangeRadio(page, subPage, event)
            }
            value={viewDataBy}
            options={[
              {
                value: 10,
                label: _("personal")
              },
              {
                value: 11,
                label: _("partnership")
              },
              {
                value: 100,
                label: _("BU")
              },
              {
                value: 101,
                label: _("zone")
              },
              {
                value: 110,
                label: _("backup")
              }
            ]}
          />
        ) : null}
      </div>
    );
  }

  renderPrivilegesBlock() {
    const {
      allowAccessToClientList,
      activateNotifications,
      allowConfigurateBudget,
      allowUpdatingBillingView,
      allowUpdatingTarifClients,
      allowUpdatingNewClients,
      allowUpdatingDepartClients,
      allowAccessToClientCollaboratorRelation,
      allowAccessToClientInformations,
      allowAccessToGlobalBudget,
      allowUpdatingOffrePrice,
      allowToAddDeleger,
      allowUpdateBudgetedBenchmark,
      allowAccessToStatisticsCards,
      allowAccessToCorrectionCards,

      allowAdjustDistributionOfTasksByRole,
      allowAttributionBU,
      allowAttributionSquad,
      allowCollabToDevCard,
      allowAttributionCluster,
      allowSelectAppliedModel,
      allowTodragAndDropFromTODO,
      allowTodragAndDropFromWIP,
      allowTodragAndDropFromDONE,
      allowTodragAndDropFromVALIDATION,

      allowAccessClientSpace,
      allowCreateCorrectionCards,
      activateCarteNotifications,
      activateCalendarNotifications,
      allowAccessToCollaboratorList,

      allowAccessReporting,
      allowAccessReportingTab,
      allowAccessProductionCapacity,
      allowAccessBonusPlan,
      allowAccessEcheance,
      allowAccessBalanceRecap,
      allowAccessCalendar,
      allowAccessTimeReport,
      allowAccessPortfolio,
      allowAccessErrReporting,
      allowAccessVacationMatrix,
      allowAccessPlans,
      allowAccessPrestation,
      allowAccessPrestaTS,
      allowAccessFinancial,
      allowAccessFinancialSheet,
      allowAccessForfait,
      allowAccessCroissance,
      allowAccessDynamicTab,
      allowAccessCapacityPlanning,
      allowAccessCapacityPlanningTab,
      allowAccessSynthesis,
      allowAccessSetting,
      allowAccessCategorySetting,
      allowAccessTaskTypeSetting,
      allowAccessCollaboratorSetting,
      allowAccessCalendarSetting,
      allowCoefficientsConfig,
      allowAccessModelSetting,
      allowAccessUserSetting,
      allowAccessSynchronization,
      allowAccessParameterSetting,
      dashboardAccess,
      clientsAccess,
      collaboratorsAccess,
      prestationsAccess,
      notificationAccess,
      cpAccess,
      settingsAccess,
      tsAccess,
      financialAccess,
      reportingAccess
    } = this.props;

    return (
      <div>
        <div className={styles.separator}>{_("generalPrivileges")}</div>
        {/* Notification preferences */}
        <div className={styles.preferences_getNotifications}>
          <div className={"switch"}>
            <span className="sidebar_role">{_("activateNotifications")}</span>
            <Switch
              name="activateNotifications"
              keyAttr="sms-create"
              isChecked={activateNotifications}
              onChange={val => this.setActivateNotifications(val)}
            />
          </div>
          <div className={"switch"}>
            <span className="sidebar_role">
              {_("activateCarteNotifications")}
            </span>
            <Switch
              name="activateCarteNotifications"
              keyAttr="sms-create"
              isChecked={activateCarteNotifications}
              onChange={val => this.setActivateCarteNotifications(val)}
            />
          </div>
          <div className={"switch"}>
            <span className="sidebar_role">
              {_("activateCalendarNotifications")}
            </span>
            <Switch
              name="activateCalendarNotifications"
              keyAttr="sms-create"
              isChecked={activateCalendarNotifications}
              onChange={val => this.setActivateCalendarNotifications(val)}
            />
          </div>
        </div>

        {/* Dashboard preferences */}
        <div className={styles.separator}>{_("dashboardPrivileges")}</div>
        <div className={styles.preferences_switch}>
          <div className={"switch"}>
            <span className="sidebar_role">{_("allowAccess")}</span>
            <Switch
              name="allowAccessDashboard"
              keyAttr="sms-create"
              isChecked={dashboardAccess.allowAccess}
              onChange={val =>
                this.setAllowAccess("dashboard", "allowAccess", val)
              }
            />
          </div>
        </div>

        {/* Clients preferences */}
        <div className={styles.separator}>{_("clientsPrivileges")}</div>
        <div className={styles.preferences_switch}>
          <div className={"switch"}>
            <span className="sidebar_role">{_("allowAccess")}</span>
            <Switch
              name="allowAccessClients"
              isChecked={clientsAccess.allowAccess}
              onChange={val =>
                this.setAllowAccess("clients", "allowAccess", val)
              }
            />
          </div>
          {clientsAccess.allowAccess && (
            <div>
              {this.renderViewDataBySwitch(
                "viewPortfolioDataBy",
                "clients",
                clientsAccess.allowViewDataBy
              )}
              <div className={"switch"}>
                <span className="sidebar_role">
                  {_("allowConfigurateBudget")}
                </span>
                <Switch
                  name="allowUpdateBudgetConfig"
                  isChecked={clientsAccess.allowUpdateBudgetConfig}
                  onChange={val =>
                    this.handleSwitch("clients", "allowUpdateBudgetConfig", val)
                  }
                />
              </div>
              <div className={"switch"}>
                <span className="sidebar_role">
                  {_("allowUpdateClientSettings")}
                </span>
                <Switch
                  name="allowUpdateClientSettings"
                  isChecked={clientsAccess.allowUpdateClientSettings}
                  onChange={val =>
                    this.handleSwitch(
                      "clients",
                      "allowUpdateClientSettings",
                      val
                    )
                  }
                />
              </div>
            </div>
          )}
        </div>

        {/* Collaborators preferences */}
        <div className={styles.separator}>{_("collaboratorsPrivileges")}</div>
        <div className={styles.preferences_switch}>
          <div className={"switch"}>
            <span className="sidebar_role">{_("allowAccess")}</span>
            <Switch
              name="allowAccessCollaborators"
              isChecked={collaboratorsAccess.allowAccess}
              onChange={val =>
                this.handleSwitch("collaborators", "allowAccess", val)
              }
            />
          </div>
          {collaboratorsAccess.allowAccess && (
            <div>
              <div className={"switch"}>
                <span className="sidebar_role">
                  {_("allowConfigCollaborator")}
                </span>
                <Switch
                  name="allowConfigCollaborator"
                  isChecked={collaboratorsAccess.allowConfigCollaborator}
                  onChange={val =>
                    this.handleSwitch(
                      "collaborators",
                      "allowConfigCollaborator",
                      val
                    )
                  }
                />
              </div>
              {this.renderViewDataBySwitch(
                "viewDataBy",
                "collaborators",
                collaboratorsAccess.allowViewDataBy
              )}
              <div className={"switch"}>
                <span className="sidebar_role">
                  {_("allowAccessProdCapacity")}
                </span>
                <Switch
                  name="allowAccessCPr"
                  isChecked={collaboratorsAccess.allowAccessCPr}
                  onChange={val =>
                    this.handleSwitch("collaborators", "allowAccessCPr", val)
                  }
                />
              </div>
              <div className={"switch"}>
                <span className="sidebar_role">{_("allowAccessPlans")}</span>
                <Switch
                  name="allowAccessPlans"
                  isChecked={collaboratorsAccess.allowAccessPlans}
                  onChange={val =>
                    this.handleSwitch("collaborators", "allowAccessPlans", val)
                  }
                />
              </div>
              {collaboratorsAccess.allowAccessPlans && (
                <Fragment>
                  <div className={"switch sub_tab"}>
                    <span className="sidebar_role">
                      {_("allowDragFromToDo")}
                    </span>
                    <Switch
                      name="allowDragFromToDo"
                      isChecked={collaboratorsAccess.allowDragFromToDo}
                      onChange={val =>
                        this.handleSwitch(
                          "collaborators",
                          "allowDragFromToDo",
                          val
                        )
                      }
                    />
                  </div>
                  <div className={"switch sub_tab"}>
                    <span className="sidebar_role">
                      {_("allowDragFromWIP")}
                    </span>
                    <Switch
                      name="allowDragFromWIP"
                      isChecked={collaboratorsAccess.allowDragFromWIP}
                      onChange={val =>
                        this.handleSwitch(
                          "collaborators",
                          "allowDragFromWIP",
                          val
                        )
                      }
                    />
                  </div>
                  <div className={"switch sub_tab"}>
                    <span className="sidebar_role">
                      {_("allowDragFromValidate")}
                    </span>
                    <Switch
                      name="allowDragFromValidate"
                      isChecked={collaboratorsAccess.allowDragFromValidate}
                      onChange={val =>
                        this.handleSwitch(
                          "collaborators",
                          "allowDragFromValidate",
                          val
                        )
                      }
                    />
                  </div>
                  <div className={"switch sub_tab"}>
                    <span className="sidebar_role">
                      {_("allowDragFromDone")}
                    </span>
                    <Switch
                      name="allowDragFromDone"
                      isChecked={collaboratorsAccess.allowDragFromDone}
                      onChange={val =>
                        this.handleSwitch(
                          "collaborators",
                          "allowDragFromDone",
                          val
                        )
                      }
                    />
                  </div>
                </Fragment>
              )}
              <div className={"switch"}>
                <span className="sidebar_role">{_("allowAccessCalendar")}</span>
                <Switch
                  name="allowAccessCalendar"
                  isChecked={collaboratorsAccess.allowAccessCalendar}
                  onChange={val =>
                    this.handleSwitch(
                      "collaborators",
                      "allowAccessCalendar",
                      val
                    )
                  }
                />
              </div>
              {collaboratorsAccess.allowAccessCalendar && (
                <div className={"switch sub_tab"}>
                  <span className="sidebar_role">
                    {_("allowValidateVacationRequest")}
                  </span>
                  <Switch
                    name="allowValidateVacationRequest"
                    isChecked={collaboratorsAccess.allowValidateVacationRequest}
                    onChange={val =>
                      this.handleSwitch(
                        "collaborators",
                        "allowValidateVacationRequest",
                        val
                      )
                    }
                  />
                </div>
              )}
              <div className={"switch"}>
                <span className="sidebar_role">
                  {_("allowAccessPlanification")}
                </span>
                <Switch
                  name="allowConfigCollaborator"
                  isChecked={collaboratorsAccess.allowAccessPlanification}
                  onChange={val =>
                    this.handleSwitch(
                      "collaborators",
                      "allowAccessPlanification",
                      val
                    )
                  }
                />
              </div>
              <div className={"switch"}>
                <span className="sidebar_role">
                  {_("allowAccessFolderCapacity")}
                </span>
                <Switch
                  name="allowAccessFolderCapacity"
                  isChecked={collaboratorsAccess.allowAccessFolderCapacity}
                  onChange={val =>
                    this.handleSwitch(
                      "collaborators",
                      "allowAccessFolderCapacity",
                      val
                    )
                  }
                />
              </div>
              <div className={"switch"}>
                <span className="sidebar_role">
                  {_("allowAccessFinancialState")}
                </span>
                <Switch
                  name="allowAccessFinancialState"
                  isChecked={collaboratorsAccess.allowAccessFinancialState}
                  onChange={val =>
                    this.handleSwitch(
                      "collaborators",
                      "allowAccessFinancialState",
                      val
                    )
                  }
                />
              </div>
              <div className={"switch"}>
                <span className="sidebar_role">{_("allowVerifyBudget")}</span>
                <Switch
                  name="allowVerifyBudget"
                  isChecked={collaboratorsAccess.allowVerifyBudget}
                  onChange={val =>
                    this.handleSwitch("collaborators", "allowVerifyBudget", val)
                  }
                />
              </div>
            </div>
          )}
        </div>

        {/* Financial preferences */}
        <div className={styles.separator}>{_("financialPrivileges")}</div>
        <div className={styles.preferences_switch}>
          <div className={"switch"}>
            <span className="sidebar_role">{_("allowAccess")}</span>
            <Switch
              name="allowAccessFianacialPage"
              isChecked={financialAccess.allowAccess}
              onChange={val =>
                this.setAllowAccess("financial", "allowAccess", val)
              }
            />
          </div>
          {financialAccess.allowAccess && (
            <Collapse
              defaultActiveKey={["1"]}
              style={{
                width: "82%",
                marginLeft: "9%",
                backgroundColor: "transparent"
              }}
            >
              <CollapsePanel header="Table Dynamique" key="1">
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessDynamicTab")}
                  </span>
                  <Switch
                    name="allowAccessDynamicTab"
                    isChecked={financialAccess.dynamicTable.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "financial",
                        "dynamicTable",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {financialAccess.dynamicTable.allowAccess &&
                  this.renderViewSubDataBySwitch(
                    "viewDataBy",
                    "financial",
                    "dynamicTable",
                    financialAccess.dynamicTable.allowViewDataBy
                  )}
              </CollapsePanel>
              <CollapsePanel header="Financial Sheet" key="2">
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessFinancial")}
                  </span>
                  <Switch
                    name="allowAccessFinancial"
                    isChecked={financialAccess.financialState.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "financial",
                        "financialState",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {financialAccess.financialState.allowAccess &&
                  this.renderViewSubDataBySwitch(
                    "viewDataBy",
                    "financial",
                    "financialState",
                    financialAccess.financialState.allowViewDataBy
                  )}
              </CollapsePanel>
              <CollapsePanel header="Forfait" key="3">
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessForfait")}
                  </span>
                  <Switch
                    name="allowAccessForfait"
                    isChecked={financialAccess.forfait.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "financial",
                        "forfait",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {financialAccess.forfait.allowAccess && (
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessRevision")}
                    </span>
                    <Switch
                      name="allowAccessRevision"
                      isChecked={financialAccess.forfait.allowLaunchRevision}
                      onChange={val =>
                        this.handleSubSwitch(
                          "financial",
                          "forfait",
                          "allowLaunchRevision",
                          val
                        )
                      }
                    />
                  </div>
                )}
              </CollapsePanel>
              <CollapsePanel header="Croissance" key="4">
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessCroissance")}
                  </span>
                  <Switch
                    name="allowAccessCroissance"
                    isChecked={financialAccess.croissance.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "financial",
                        "croissance",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {financialAccess.croissance.allowAccess && (
                  <Fragment>
                    {this.renderViewSubDataBySwitch(
                      "viewDataBy",
                      "financial",
                      "croissance",
                      financialAccess.croissance.allowViewDataBy
                    )}
                    <div className={"switch"}>
                      <span className="sidebar_role">
                        {_("allowAccessClientIn")}
                      </span>
                      <Switch
                        name="allowAccessClientIn"
                        isChecked={financialAccess.croissance.allowAccessIN}
                        onChange={val =>
                          this.setAllowSubAccess(
                            "financial",
                            "croissance",
                            "allowAccessIN",
                            val
                          )
                        }
                      />
                    </div>
                    <div className={"switch"}>
                      <span className="sidebar_role">
                        {_("allowAccessClientOut")}
                      </span>
                      <Switch
                        name="allowAccessClientOut"
                        isChecked={financialAccess.croissance.allowAccessOUT}
                        onChange={val =>
                          this.setAllowSubAccess(
                            "financial",
                            "croissance",
                            "allowAccessOUT",
                            val
                          )
                        }
                      />
                    </div>
                    <div className={"switch"}>
                      <span className="sidebar_role">
                        {_("allowAccessClientRisky")}
                      </span>
                      <Switch
                        name="allowAccessClientRisky"
                        isChecked={financialAccess.croissance.allowAccessRisky}
                        onChange={val =>
                          this.setAllowSubAccess(
                            "financial",
                            "croissance",
                            "allowAccessRisky",
                            val
                          )
                        }
                      />
                    </div>
                    <div className={"switch"}>
                      <span className="sidebar_role">
                        {_("allowAccessReview")}
                      </span>
                      <Switch
                        name="allowAccessReview"
                        isChecked={financialAccess.croissance.allowAccessReview}
                        onChange={val =>
                          this.setAllowSubAccess(
                            "financial",
                            "croissance",
                            "allowAccessReview",
                            val
                          )
                        }
                      />
                    </div>
                  </Fragment>
                )}
              </CollapsePanel>
            </Collapse>
          )}
        </div>

        {/* Prestations preferences */}
        <div className={styles.separator}>{_("prestationsPrivileges")}</div>
        <div className={styles.preferences_switch}>
          <div className={"switch"}>
            <span className="sidebar_role">{_("allowAccess")}</span>
            <Switch
              name="allowAccessPrestations"
              isChecked={prestationsAccess.allowAccess}
              onChange={val =>
                this.setAllowAccess("prestations", "allowAccess", val)
              }
            />
          </div>
          {prestationsAccess.allowAccess && (
            <div>
              {this.renderViewDataBySwitch(
                "viewTimeSheetDataBy",
                "prestations",
                prestationsAccess.allowViewDataBy
              )}
            </div>
          )}
        </div>

        {/* Reporting preferences */}
        <div className={styles.separator}>{_("reportingPrivileges")}</div>
        <div className={styles.preferences_switch}>
          <div className={"switch"}>
            <span className="sidebar_role">{_("allowAccess")}</span>
            <Switch
              name="allowAccessReportingPage"
              isChecked={reportingAccess.allowAccess}
              onChange={val =>
                this.setAllowAccess("reporting", "allowAccess", val)
              }
            />
          </div>
          {reportingAccess.allowAccess && (
            <Collapse
              defaultActiveKey={["1x"]}
              style={{
                width: "82%",
                marginLeft: "9%",
                backgroundColor: "transparent"
              }}
            >
              <CollapsePanel header="Suivi de Production" key="1x">
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessProdCapacity")}
                  </span>
                  <Switch
                    name="allowAccessProdCapacity"
                    isChecked={reportingAccess.production.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "reporting",
                        "production",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {reportingAccess.production.allowAccess &&
                  this.renderViewSubDataBySwitch(
                    "viewDataBy",
                    "reporting",
                    "production",
                    reportingAccess.production.allowViewDataBy
                  )}
              </CollapsePanel>
              <CollapsePanel header="Développement Individuel BE" key="2x">
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessIndivDevBe")}
                  </span>
                  <Switch
                    name="allowAccessIndivDevBe"
                    isChecked={reportingAccess.individualDevBe.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "reporting",
                        "individualDevBe",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {reportingAccess.individualDevBe.allowAccess &&
                  this.renderViewSubDataBySwitch(
                    "viewDataBy",
                    "reporting",
                    "individualDevBe",
                    reportingAccess.individualDevBe.allowViewDataBy
                  )}
              </CollapsePanel>
              <CollapsePanel header="Développement Individuel MA" key="3x">
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessIndivDevMa")}
                  </span>
                  <Switch
                    name="allowAccessIndivDevMa"
                    isChecked={reportingAccess.individualDevMa.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "reporting",
                        "individualDevMa",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {reportingAccess.individualDevMa.allowAccess &&
                  this.renderViewSubDataBySwitch(
                    "viewDataBy",
                    "reporting",
                    "individualDevMa",
                    reportingAccess.individualDevMa.allowViewDataBy
                  )}
              </CollapsePanel>
              <CollapsePanel header="Suivi d'Echéances" key="4x">
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessEcheance")}
                  </span>
                  <Switch
                    name="allowAccessEcheance"
                    isChecked={reportingAccess.echeance.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "reporting",
                        "echeance",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {reportingAccess.echeance.allowAccess &&
                  this.renderViewSubDataBySwitch(
                    "viewDataBy",
                    "reporting",
                    "echeance",
                    reportingAccess.echeance.allowViewDataBy
                  )}
              </CollapsePanel>
              <CollapsePanel header="Récapitulatif Bilans" key="5x">
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessCardsStatistics")}
                  </span>
                  <Switch
                    name="allowAccessCardsStatistics"
                    isChecked={reportingAccess.allowAccessCardsStatistics}
                    onChange={val =>
                      this.handleSwitch(
                        "reporting",
                        "allowAccessCardsStatistics",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessBalanceRecap")}
                  </span>
                  <Switch
                    name="allowAccessBalanceRecap"
                    isChecked={reportingAccess.recapBalance.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "reporting",
                        "recapBalance",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {reportingAccess.recapBalance.allowAccess &&
                  this.renderViewSubDataBySwitch(
                    "viewDataBy",
                    "reporting",
                    "recapBalance",
                    reportingAccess.recapBalance.allowViewDataBy
                  )}
              </CollapsePanel>
              <CollapsePanel header="Calendrier" key="6x">
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessCalendar")}
                  </span>
                  <Switch
                    name="allowAccessReportingCalendar"
                    isChecked={reportingAccess.calendar.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "reporting",
                        "calendar",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {reportingAccess.calendar.allowAccess &&
                  this.renderViewSubDataBySwitch(
                    "viewDataBy",
                    "reporting",
                    "calendar",
                    reportingAccess.calendar.allowViewDataBy
                  )}
              </CollapsePanel>
              <CollapsePanel header="Suivi de Temps" key="7x">
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessTimeReport")}
                  </span>
                  <Switch
                    name="allowAccessTimeReport"
                    isChecked={reportingAccess.timesheet.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "reporting",
                        "timesheet",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {reportingAccess.timesheet.allowAccess &&
                  this.renderViewSubDataBySwitch(
                    "viewDataBy",
                    "reporting",
                    "timesheet",
                    reportingAccess.timesheet.allowViewDataBy
                  )}
              </CollapsePanel>
              <CollapsePanel header="Suivi des Portefeuilles" key="8x">
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessPortfolio")}
                  </span>
                  <Switch
                    name="allowAccessPortfolio"
                    isChecked={reportingAccess.portfolio.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "reporting",
                        "portfolio",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {reportingAccess.portfolio.allowAccess &&
                  this.renderViewSubDataBySwitch(
                    "viewDataBy",
                    "reporting",
                    "portfolio",
                    reportingAccess.portfolio.allowViewDataBy
                  )}
              </CollapsePanel>
              <CollapsePanel header="Supervision" key="9x">
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessErrReporting")}
                  </span>
                  <Switch
                    name="allowAccessErrReporting"
                    isChecked={reportingAccess.supervision.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "reporting",
                        "supervision",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {reportingAccess.supervision.allowAccess &&
                  this.renderViewSubDataBySwitch(
                    "viewDataBy",
                    "reporting",
                    "supervision",
                    reportingAccess.supervision.allowViewDataBy
                  )}
              </CollapsePanel>
              <CollapsePanel header="Matrice de Congé" key="10x">
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessVacationMatrix")}
                  </span>
                  <Switch
                    name="allowAccessVacationMatrix"
                    isChecked={reportingAccess.vacation.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "reporting",
                        "vacation",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {reportingAccess.vacation.allowAccess &&
                  this.renderViewSubDataBySwitch(
                    "viewDataBy",
                    "reporting",
                    "vacation",
                    reportingAccess.vacation.allowViewDataBy
                  )}
              </CollapsePanel>
              <CollapsePanel header="Gestion des Plans" key="11x">
                <div className={"switch"}>
                  <span className="sidebar_role">{_("allowAccessPlans")}</span>
                  <Switch
                    name="allowAccessPlans"
                    isChecked={reportingAccess.plans.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "reporting",
                        "plans",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {reportingAccess.plans.allowAccess &&
                  this.renderViewSubDataBySwitch(
                    "viewDataBy",
                    "reporting",
                    "plans",
                    reportingAccess.plans.allowViewDataBy
                  )}
              </CollapsePanel>
              <CollapsePanel header="Suivi des Prestations" key="12x">
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessPrestation")}
                  </span>
                  <Switch
                    name="allowAccessPrestation"
                    isChecked={reportingAccess.prestations.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "reporting",
                        "prestations",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {reportingAccess.prestations.allowAccess &&
                  this.renderViewSubDataBySwitch(
                    "viewDataBy",
                    "reporting",
                    "prestations",
                    reportingAccess.prestations.allowViewDataBy
                  )}
              </CollapsePanel>
            </Collapse>
          )}
        </div>

        {/* Capacity Planning preferences */}
        <div className={styles.separator}>{_("cpPrivileges")}</div>
        <div className={styles.preferences_switch}>
          <div className={"switch"}>
            <span className="sidebar_role">{_("allowAccess")}</span>
            <Switch
              name="allowAccessCapcityPlan"
              isChecked={prestationsAccess.allowAccess}
              onChange={val =>
                this.setAllowAccess("capacityPlanning", "allowAccess", val)
              }
            />
          </div>
          {cpAccess.allowAccess && (
            <div>
              {this.renderViewDataBySwitch(
                "viewCPlanningDataBy",
                "capacityPlanning",
                cpAccess.allowViewDataBy
              )}
            </div>
          )}
        </div>

        {/* Notification preferences */}
        <div className={styles.separator}>{_("notificationPrivileges")}</div>
        <div className={styles.preferences_switch}>
          <div className={"switch"}>
            <span className="sidebar_role">{_("allowAccess")}</span>
            <Switch
              name="allowAccessNotification"
              isChecked={notificationAccess.allowAccess}
              onChange={val =>
                this.setAllowAccess("notifications", "allowAccess", val)
              }
            />
          </div>
          {notificationAccess.allowAccess && (
            <Collapse
              defaultActiveKey={["1"]}
              style={{
                width: "82%",
                marginLeft: "9%",
                backgroundColor: "transparent"
              }}
            >
              <CollapsePanel header="Notification Supervision" key="1">
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("viewNotificationSupervisionDataBy")}
                  </span>
                  <Switch
                    name="allowAccessNotificationSupervision"
                    isChecked={notificationAccess.supervision.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "notifications",
                        "supervision",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {notificationAccess.supervision.allowAccess &&
                  this.renderViewSubDataByRadio(
                    "viewDataBy",
                    "notifications",
                    "supervision",
                    notificationAccess.supervision.allowViewDataBy
                  )}
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("getValidationNotifSupervisionBy")}
                  </span>
                  <Switch
                    name="allowValidationRequestSupervision"
                    isChecked={
                      notificationAccess.validationRequestSupervision
                        .allowAccess
                    }
                    onChange={val =>
                      this.setAllowSubAccess(
                        "notifications",
                        "validationRequestSupervision",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {notificationAccess.validationRequestSupervision.allowAccess &&
                  this.renderViewSubDataByRadio(
                    "viewDataBy",
                    "notifications",
                    "validationRequestSupervision",
                    notificationAccess.validationRequestSupervision
                      .allowViewDataBy
                  )}
              </CollapsePanel>
              <CollapsePanel
                header="Notification Rapport de Supervision"
                key="22"
              >
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("viewNotificationSupervisionRepportDataBy")}
                  </span>
                  <Switch
                    name="allowAccessNotificationSupervisionRepport"
                    isChecked={
                      notificationAccess.supervisionRepport.allowAccess
                    }
                    onChange={val =>
                      this.setAllowSubAccess(
                        "notifications",
                        "supervisionRepport",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {notificationAccess.supervisionRepport.allowAccess &&
                  this.renderViewSubDataByRadio(
                    "viewDataBy",
                    "notifications",
                    "supervisionRepport",
                    notificationAccess.supervisionRepport.allowViewDataBy
                  )}
              </CollapsePanel>
              <CollapsePanel header="Notification Calendar" key="1">
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("viewNotificationCalendarAttachmentRequestBy")}
                  </span>
                  <Switch
                    name="allowAccessNotificationAttachmentRequestCalendar"
                    isChecked={notificationAccess.attachmentRequest.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "notifications",
                        "attachmentRequest",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {notificationAccess.attachmentRequest.allowAccess &&
                  this.renderViewSubDataByRadio(
                    "viewDataBy",
                    "notifications",
                    "attachmentRequest",
                    notificationAccess.attachmentRequest.allowViewDataBy
                  )}
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("getNotificationAbsenceRequestBy")}
                  </span>
                  <Switch
                    name="allowAbsenceStatus"
                    isChecked={notificationAccess.absenceRequest.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "notifications",
                        "absenceRequest",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {notificationAccess.absenceRequest.allowAccess &&
                  this.renderViewSubDataByRadio(
                    "viewDataBy",
                    "notifications",
                    "absenceRequest",
                    notificationAccess.absenceRequest.allowViewDataBy
                  )}
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("getNotificationAbsenceStatusBy")}
                  </span>
                  <Switch
                    name="allowAbsenceStatus"
                    isChecked={notificationAccess.absenceStatus.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "notifications",
                        "absenceStatus",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {notificationAccess.absenceStatus.allowAccess &&
                  this.renderViewSubDataByRadio(
                    "viewDataBy",
                    "notifications",
                    "absenceStatus",
                    notificationAccess.absenceStatus.allowViewDataBy
                  )}
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("getNotificationAbsenceAssignmentBy")}
                  </span>
                  <Switch
                    name="allowAbsenceAssignment"
                    isChecked={notificationAccess.absenceAssignment.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "notifications",
                        "absenceAssignment",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {notificationAccess.absenceAssignment.allowAccess &&
                  this.renderViewSubDataByRadio(
                    "viewDataBy",
                    "notifications",
                    "absenceAssignment",
                    notificationAccess.absenceAssignment.allowViewDataBy
                  )}
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("getNotificationAbsenceBackupBy")}
                  </span>
                  <Switch
                    name="allowAbsenceBackup"
                    isChecked={notificationAccess.absenceBackup.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "notifications",
                        "absenceBackup",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {notificationAccess.absenceBackup.allowAccess &&
                  this.renderViewSubDataByRadio(
                    "viewDataBy",
                    "notifications",
                    "absenceBackup",
                    notificationAccess.absenceBackup.allowViewDataBy
                  )}
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("getNotificationSickLeaveBy")}
                  </span>
                  <Switch
                    name="allowSickLeave"
                    isChecked={notificationAccess.sickLeave.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "notifications",
                        "sickLeave",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {notificationAccess.sickLeave.allowAccess &&
                  this.renderViewSubDataByRadio(
                    "viewDataBy",
                    "notifications",
                    "sickLeave",
                    notificationAccess.sickLeave.allowViewDataBy
                  )}
              </CollapsePanel>
              <CollapsePanel header="Notification Time-Sheet" key="1">
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("viewNotificationTSReminderBy")}
                  </span>
                  <Switch
                    name="allowAccessNotificationTSReminderCalendar"
                    isChecked={notificationAccess.tsReminder.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "notifications",
                        "tsReminder",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {notificationAccess.tsReminder.allowAccess &&
                  this.renderViewSubDataByRadio(
                    "viewDataBy",
                    "notifications",
                    "tsReminder",
                    notificationAccess.tsReminder.allowViewDataBy
                  )}
              </CollapsePanel>
              <CollapsePanel header="Notification Croissance" key="1">
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("viewNotificationCroissanceInBy")}
                  </span>
                  <Switch
                    name="allowAccessNotificationcroissanceIn"
                    isChecked={notificationAccess.croissanceIn.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "notifications",
                        "croissanceIn",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {notificationAccess.croissanceIn.allowAccess &&
                  this.renderViewSubDataByRadio(
                    "viewDataBy",
                    "notifications",
                    "croissanceIn",
                    notificationAccess.croissanceIn.allowViewDataBy
                  )}
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("viewNotificationCroissanceOutBy")}
                  </span>
                  <Switch
                    name="allowAccessNotificationCroissanceOut"
                    isChecked={notificationAccess.croissanceOut.allowAccess}
                    onChange={val =>
                      this.setAllowSubAccess(
                        "notifications",
                        "croissanceOut",
                        "allowAccess",
                        val
                      )
                    }
                  />
                </div>
                {notificationAccess.croissanceOut.allowAccess &&
                  this.renderViewSubDataByRadio(
                    "viewDataBy",
                    "notifications",
                    "croissanceOut",
                    notificationAccess.croissanceOut.allowViewDataBy
                  )}
              </CollapsePanel>
            </Collapse>
          )}
        </div>

        {/* Settings preferences */}
        <div className={styles.separator}>{_("settingPrivileges")}</div>
        <div className={styles.preferences_switch}>
          <div className={"switch"}>
            <span className="sidebar_role">{_("allowAccess")}</span>
            <Switch
              name="allowAccessSettings"
              isChecked={settingsAccess.allowAccess}
              onChange={val => {
                this.setAllowAccess("settings", "allowAccess", val);
                this.handleSwitch("settings", "allowAccessCollaborators", val);
              }}
            />
          </div>
          {settingsAccess.allowAccess && (
            <div>
              <div className={"switch"}>
                <span className="sidebar_role">
                  {_("allowAccessCategories")}
                </span>
                <Switch
                  name="allowAccessSettings"
                  isChecked={settingsAccess.allowAccessCategories}
                  onChange={val =>
                    this.handleSwitch("settings", "allowAccessCategories", val)
                  }
                />
              </div>
              <div className={"switch"}>
                <span className="sidebar_role">
                  {_("allowAccessTaskTypes")}
                </span>
                <Switch
                  name="allowAccessTaskTypes"
                  isChecked={settingsAccess.allowAccessTaskTypes}
                  onChange={val =>
                    this.handleSwitch("settings", "allowAccessTaskTypes", val)
                  }
                />
              </div>
              <div className={"switch"}>
                <span className="sidebar_role">
                  {_("allowAccessCollaborators")}
                </span>
                <Switch
                  name="allowAccessCollaborators"
                  isChecked={settingsAccess.allowAccessCollaborators}
                  onChange={val =>
                    this.handleSwitch(
                      "settings",
                      "allowAccessCollaborators",
                      val
                    )
                  }
                />
              </div>
              <div className={"switch"}>
                <span className="sidebar_role">
                  {_("allowAccessCalendarSet")}
                </span>
                <Switch
                  name="allowAccessCalendarSettings"
                  isChecked={settingsAccess.allowAccessCalendar}
                  onChange={val =>
                    this.handleSwitch("settings", "allowAccessCalendar", val)
                  }
                />
              </div>
              <div className={"switch"}>
                <span className="sidebar_role">{_("allowCoeffConfigSet")}</span>
                <Switch
                  name="allowCoefficientsConfig"
                  isChecked={settingsAccess.allowCoefficientsConfig}
                  onChange={val =>
                    this.handleSwitch(
                      "settings",
                      "allowCoefficientsConfig",
                      val
                    )
                  }
                />
              </div>
              <div className={"switch"}>
                <span className="sidebar_role">
                  {_("allowAccessParameters")}
                </span>
                <Switch
                  name="allowAccessParameters"
                  isChecked={settingsAccess.allowAccessParameters}
                  onChange={val =>
                    this.handleSwitch("settings", "allowAccessParameters", val)
                  }
                />
              </div>
              <div className={"switch"}>
                <span className="sidebar_role">{_("allowAccessUsers")}</span>
                <Switch
                  name="allowAccessUsers"
                  isChecked={settingsAccess.allowAccessUsers}
                  onChange={val =>
                    this.handleSwitch("settings", "allowAccessUsers", val)
                  }
                />
              </div>
              <div className={"switch"}>
                <span className="sidebar_role">
                  {_("allowAccessSynchronization")}
                </span>
                <Switch
                  name="allowAccessSynchro"
                  isChecked={settingsAccess.allowAccessSynchronization}
                  onChange={val =>
                    this.handleSwitch(
                      "settings",
                      "allowAccessSynchronization",
                      val
                    )
                  }
                />
              </div>
              <div className={"switch"}>
                <span className="sidebar_role">{_("allowAccessModels")}</span>
                <Switch
                  name="allowAccessModels"
                  isChecked={settingsAccess.allowAccessModels}
                  onChange={val =>
                    this.handleSwitch("settings", "allowAccessModels", val)
                  }
                />
              </div>
            </div>
          )}
        </div>

        {/* Timesheet preferences */}
        <div className={styles.separator}>{_("timesheetPrivileges")}</div>
        <div className={styles.preferences_switch}>
          <div className={"switch"}>
            <span className="sidebar_role">{_("allowAccess")}</span>
            <Switch
              name="allowAccessPrestations"
              isChecked={tsAccess.allowAccess}
              onChange={val =>
                this.setAllowAccess("timesheet", "allowAccess", val)
              }
            />
          </div>
          {tsAccess.allowAccess && (
            <div>
              {this.renderViewDataBySwitch(
                "viewDataBy",
                "timesheet",
                tsAccess.allowViewDataBy
              )}
            </div>
          )}
        </div>

        <div>
          <div
            onClick={() =>
              this.setState(prevState => ({
                ...prevState,
                expanded: !prevState.expanded
              }))
            }
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "20px 50px",
              cursor: "pointer"
            }}
          >
            <h5>{_("deprecated")}</h5>
            <i
              className={"icon icon-arrow-down"}
              style={{
                transform: this.state.expanded ? "rotate(0)" : "rotate(-90deg)"
              }}
            />
          </div>
          {this.state.expanded && (
            <Fragment>
              <div className={styles.separator}>{_("clientsPrivileges")}</div>
              <div className={styles.preferences_switch}>
                <div className={"switch"}>
                  <span className="sidebar_role">{_("accessClientList")}</span>
                  <Switch
                    name="accessToClientList"
                    keyAttr="access-client-list"
                    isChecked={allowAccessToClientList}
                    onChange={val => this.setAllowAccessToClientList(val)}
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessToClientCollaboratorRelation")}
                  </span>
                  <Switch
                    name="accessToClientCollaboratorRelation"
                    keyAttr="access-collaborator-relation"
                    isChecked={allowAccessToClientCollaboratorRelation}
                    onChange={val =>
                      this.setAllowAccessToClientCollaboratorRelation(val)
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessToStatisticsCards")}
                  </span>
                  <Switch
                    name="accessToStatisticsCards"
                    keyAttr="access-statistics-cards"
                    isChecked={allowAccessToStatisticsCards}
                    onChange={val => this.setAllowAccessToStatisticsCards(val)}
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessToCorrectionCards")}
                  </span>
                  <Switch
                    name="accessToCorrectionCards"
                    keyAttr="access-correction-cards"
                    isChecked={allowAccessToCorrectionCards}
                    onChange={val => this.setAllowAccessToCorrectionCards(val)}
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowCreateCorrectionCards")}
                  </span>
                  <Switch
                    name="allowCreateCorrectionCards"
                    keyAttr="access-create_cor_card"
                    isChecked={allowCreateCorrectionCards}
                    onChange={val => this.setAllowCreateCorrectionCards(val)}
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowConfigurateBudget")}
                  </span>
                  <Switch
                    name="configurateBudget"
                    keyAttr="budget-configurate"
                    isChecked={allowConfigurateBudget}
                    onChange={val => this.setAllowConfigurateBudget(val)}
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessClientSpace")}
                  </span>
                  <Switch
                    name="allowAccessClientSpace"
                    keyAttr="access-space-client"
                    isChecked={allowAccessClientSpace}
                    onChange={val => this.setAllowAccessClientSpace(val)}
                  />
                </div>
                <div className={styles.separator}>{_("BudgetPrivileges")}</div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessToClientInformations")}
                  </span>
                  <Switch
                    name="accessToClientInformations"
                    keyAttr="Allow_Access_To_Client_Informations"
                    isChecked={allowAccessToClientInformations}
                    onChange={val =>
                      this.setAllowAccessToClientInformations(val)
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessToGlobalBudget")}
                  </span>
                  <Switch
                    name="accessToGlobalBudget"
                    keyAttr="access_To_Global_Budget"
                    isChecked={allowAccessToGlobalBudget}
                    onChange={val => this.setAllowAccessToGlobalBudget(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAttributionBU")}
                  </span>
                  <Switch
                    name="allowAttributionBU"
                    keyAttr="attribution-BU"
                    isChecked={allowAttributionBU}
                    onChange={val => this.setAllowAttributionBU(val)}
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAttributionSquad")}
                  </span>
                  <Switch
                    name="allowAttributionSquad"
                    keyAttr="attribution-Squad"
                    isChecked={allowAttributionSquad}
                    onChange={val => this.setAllowAttributionSquad(val)}
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAttributionCluster")}
                  </span>
                  <Switch
                    name="allowAttributionCluster"
                    keyAttr="allow-attribution-Cluster"
                    isChecked={allowAttributionCluster}
                    onChange={val => this.setAllowAttributionCluster(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAdjustDistributionOfTasksByRole")}
                  </span>
                  <Switch
                    name="allowAdjustDistributionOfTasksByRole"
                    keyAttr="adjustDistribution-Of-Tasks-By-Role"
                    isChecked={allowAdjustDistributionOfTasksByRole}
                    onChange={val =>
                      this.setAllowAdjustDistributionOfTasksByRole(val)
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowSelectAppliedModel")}
                  </span>
                  <Switch
                    name="allowSelectAppliedModel"
                    keyAttr="allow-Select-Applied-Model"
                    isChecked={allowSelectAppliedModel}
                    onChange={val => this.setAllowSelectAppliedModel(val)}
                  />
                </div>

                {/* paramas client */}
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowUpdatingBillingView")}
                  </span>
                  <Switch
                    name="updatingBillingView"
                    keyAttr="allow-updating-billing-view"
                    isChecked={allowUpdatingBillingView}
                    onChange={val => this.setAllowUpdatingBillingView(val)}
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowUpdatingTarifClients")}
                  </span>
                  <Switch
                    name="updatingTarifClients"
                    keyAttr="allow-updating-tarif-clients"
                    isChecked={allowUpdatingTarifClients}
                    onChange={val => this.setAllowUpdatingTarifClients(val)}
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowUpdatingNewClients")}
                  </span>
                  <Switch
                    name="updatingNewClients"
                    keyAttr="allow-updating-new-clients"
                    isChecked={allowUpdatingNewClients}
                    onChange={val => this.setAllowUpdatingNewClients(val)}
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowUpdatingDepartClients")}
                  </span>
                  <Switch
                    name="updateDepartClient"
                    keyAttr="allow-update-depart-client"
                    isChecked={allowUpdatingDepartClients}
                    onChange={val => this.setAllowUpdatingDepartClients(val)}
                  />
                </div>
                {/* end params client */}

                <div className={"switch"}>
                  <span className="sidebar_role">{_("allowToAddDeleger")}</span>
                  <Switch
                    name="allowToAddDeleger"
                    keyAttr="allow-To-Add-Deleger"
                    isChecked={allowToAddDeleger}
                    onChange={val => this.setAllowToAddDeleger(val)}
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowUpdateBudgetedBenchmark")}
                  </span>
                  <Switch
                    name="update-Budgeted-Benchmark"
                    keyAttr="allow-Update-Budgeted-Benchmark"
                    isChecked={allowUpdateBudgetedBenchmark}
                    onChange={val => this.setAllowUpdateBudgetedBenchmark(val)}
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowUpdatingOffrePrice")}
                  </span>
                  <Switch
                    name="updatingOffrePrice"
                    keyAttr="allowUpdating-Offre-Price"
                    isChecked={allowUpdatingOffrePrice}
                    onChange={val => this.setAllowUpdatingOffrePrice(val)}
                  />
                </div>
              </div>
              <div className={styles.separator}>
                {_("gestionPlansPrivileges")}
              </div>
              <div className={"switch"}>
                <span className="sidebar_role">
                  {_("allowTodragAndDropFromTODO")}
                </span>
                <Switch
                  name="allowTodragAndDropFromTODO"
                  keyAttr="drag-And-Drop-From-TODO"
                  isChecked={allowTodragAndDropFromTODO}
                  onChange={val => this.setAllowTodragAndDropFromTODO(val)}
                />
              </div>
              <div className={"switch"}>
                <span className="sidebar_role">
                  {_("allowTodragAndDropFromWIP")}
                </span>
                <Switch
                  name="allowTodragAndDropFromWIP"
                  keyAttr="drag-And-Drop-From-WIP"
                  isChecked={allowTodragAndDropFromWIP}
                  onChange={val => this.setAllowTodragAndDropFromWIP(val)}
                />
              </div>
              <div className={"switch"}>
                <span className="sidebar_role">
                  {_("allowTodragAndDropFromDONE")}
                </span>
                <Switch
                  name="allowTodragAndDropFromDONE"
                  keyAttr="drag-And-Drop-From-DONE"
                  isChecked={allowTodragAndDropFromDONE}
                  onChange={val => this.setAllowTodragAndDropFromDONE(val)}
                />
              </div>
              <div className={"switch"}>
                <span className="sidebar_role">
                  {_("allowTodragAndDropFromVALIDATION")}
                </span>
                <Switch
                  name="allowTodragAndDropFromVALIDATION"
                  keyAttr="drag-And-Drop-From-VALIDATION"
                  isChecked={allowTodragAndDropFromVALIDATION}
                  onChange={val =>
                    this.setAllowTodragAndDropFromVALIDATION(val)
                  }
                />
              </div>

              <div className={styles.separator}>
                {_("collaboratorsPrivileges")}
              </div>
              <div className={styles.preferences_switch}>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessCollaboratorList")}
                  </span>
                  <Switch
                    name="allowAccessToCollaboratorList"
                    keyAttr="sms-create"
                    isChecked={allowAccessToCollaboratorList}
                    onChange={val => this.setAllowAccessToCollaboratorList(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowCollabToDevCard")}
                  </span>
                  <Switch
                    name="allowCollabToDevCard"
                    keyAttr="allow-Collab-To-Dev-Card"
                    isChecked={allowCollabToDevCard}
                    onChange={val => this.setAllowCollabToDevCard(val)}
                  />
                </div>
              </div>

              {/* -----------------------
                *   Start - Reporting   *
                ------------------------*/}
              <div className={styles.separator}>{_("reportingPrivileges")}</div>
              <div className={styles.preferences_switch}>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessReporting")}
                  </span>
                  <Switch
                    name="allowAccessReporting"
                    keyAttr="reporting-page"
                    isChecked={allowAccessReporting}
                    onChange={val => this.setAllowAccessReporting(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessReportingTab")}
                  </span>
                  <Switch
                    name="allowAccessReportingTab"
                    keyAttr="reporting-reporting"
                    isChecked={allowAccessReportingTab}
                    onChange={val => this.setAllowAccessReportingTab(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessProdCapacity")}
                  </span>
                  <Switch
                    name="allowAccessProdCapacity"
                    keyAttr="reporting-prod-capacity"
                    isChecked={allowAccessProductionCapacity}
                    onChange={val => this.setAllowAccessProductionCapacity(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessBonusPlan")}
                  </span>
                  <Switch
                    name="allowAccessBonusPlan"
                    keyAttr="reporting-bonus-plan"
                    isChecked={allowAccessBonusPlan}
                    onChange={val => this.setAllowAccessBonusPlan(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessEcheance")}
                  </span>
                  <Switch
                    name="allowAccessEcheance"
                    keyAttr="reporting-echeance"
                    isChecked={allowAccessEcheance}
                    onChange={val => this.setAllowAccessEcheance(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessBalanceRecap")}
                  </span>
                  <Switch
                    name="allowAccessBalanceRecap"
                    keyAttr="reporting-balance-recap"
                    isChecked={allowAccessBalanceRecap}
                    onChange={val => this.setAllowAccessBalanceRecap(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessCalendar")}
                  </span>
                  <Switch
                    name="allowAccessCalendar"
                    keyAttr="reporting-calendar"
                    isChecked={allowAccessCalendar}
                    onChange={val => this.setAllowAccessCalendar(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessTimeReport")}
                  </span>
                  <Switch
                    name="allowAccessTimeReport"
                    keyAttr="reporting-time-report"
                    isChecked={allowAccessTimeReport}
                    onChange={val => this.setAllowAccessTimeReport(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessPortfolio")}
                  </span>
                  <Switch
                    name="allowAccessPortfolio"
                    keyAttr="reporting-portfolio"
                    isChecked={allowAccessPortfolio}
                    onChange={val => this.setAllowAccessPortfolios(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessErrReporting")}
                  </span>
                  <Switch
                    name="allowAccessErrReporting"
                    keyAttr="reporting-err-reporting"
                    isChecked={allowAccessErrReporting}
                    onChange={val => this.setAllowAccessErrorReporting(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessVacationMatrix")}
                  </span>
                  <Switch
                    name="allowAccessVacMatrix"
                    keyAttr="reporting-vac-matrix"
                    isChecked={allowAccessVacationMatrix}
                    onChange={val => this.setAllowAccessVacationMatrix(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">{_("allowAccessPlans")}</span>
                  <Switch
                    name="allowAccessPlan"
                    keyAttr="reporting-plans"
                    isChecked={allowAccessPlans}
                    onChange={val => this.setAllowAccessPlans(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessPrestation")}
                  </span>
                  <Switch
                    name="allowAccessPrestation"
                    keyAttr="reporting-prestation"
                    isChecked={allowAccessPrestation}
                    onChange={val => this.setAllowAccessPrestations(val)}
                  />
                </div>
              </div>

              {/* -----------------------
                *   Start - Financial   *
                ------------------------*/}
              <div className={styles.separator}>{_("financialPrivileges")}</div>
              <div className={styles.preferences_switch}>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessFinancial")}
                  </span>
                  <Switch
                    name="allowAccessFinancial"
                    keyAttr="financial-page"
                    isChecked={allowAccessFinancial}
                    onChange={val => this.setAllowAccessFinancial(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessFinancialSheet")}
                  </span>
                  <Switch
                    name="allowAccessFinancialSheet"
                    keyAttr="financial-financial-sheet"
                    isChecked={allowAccessFinancialSheet}
                    onChange={val => this.setAllowAccessFinancialSheet(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessForfait")}
                  </span>
                  <Switch
                    name="allowAccessForfait"
                    keyAttr="financial-forfait"
                    isChecked={allowAccessForfait}
                    onChange={val => this.setAllowAccessForfait(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessCroissance")}
                  </span>
                  <Switch
                    name="allowAccessCroissance"
                    keyAttr="financial-croissance"
                    isChecked={allowAccessCroissance}
                    onChange={val => this.setAllowAccessCroissance(val)}
                  />
                </div>
              </div>

              <div className={styles.separator}>{_("supPrivileges")}</div>
              <div className={styles.preferences_switch}>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessPrestaTS")}
                  </span>
                  <Switch
                    name="allowAccessPrestaTS"
                    keyAttr="prestaTS-page"
                    isChecked={allowAccessPrestaTS}
                    onChange={val => this.setAllowAccessPrestaTS(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessDynamicTab")}
                  </span>
                  <Switch
                    name="allowAccessDynamicTab"
                    keyAttr="dynamic-tab-page"
                    isChecked={allowAccessDynamicTab}
                    onChange={val => this.setAllowAccessDynamicTable(val)}
                  />
                </div>
              </div>

              {/* -----------------------
                *   Start - Capacity Planning   *
                ------------------------*/}
              <div className={styles.separator}>{_("capPlanPrivileges")}</div>
              <div className={styles.preferences_switch}>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessCapPlan")}
                  </span>
                  <Switch
                    name="allowAccessCapPlan"
                    keyAttr="capacity-planning-page"
                    isChecked={allowAccessCapacityPlanning}
                    onChange={val => this.setAllowAccessCapacityPlanning(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessCapPlanTab")}
                  </span>
                  <Switch
                    name="allowAccessCapPlanTab"
                    keyAttr="capacity-planning-tab"
                    isChecked={allowAccessCapacityPlanningTab}
                    onChange={val =>
                      this.setAllowAccessCapacityPlanningTab(val)
                    }
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">{_("allowAccessSynt")}</span>
                  <Switch
                    name="allowAccessSynt"
                    keyAttr="capacity-planning-synthesis"
                    isChecked={allowAccessSynthesis}
                    onChange={val => this.setAllowAccessSyncthesis(val)}
                  />
                </div>
              </div>

              {/* --------------------------------
                *   Start - Setting Privileges   *
                ---------------------------------*/}
              <div className={styles.separator}>{_("settingPrivileges")}</div>
              <div className={styles.preferences_switch}>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessSetting")}
                  </span>
                  <Switch
                    name="allowAccessSetting"
                    keyAttr="setting-page"
                    isChecked={allowAccessSetting}
                    onChange={val => this.setAllowAccessSetting(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">{_("allowAccessCatSet")}</span>
                  <Switch
                    name="allowAccessCatSet"
                    keyAttr="category-setting-page"
                    isChecked={allowAccessCategorySetting}
                    onChange={val => this.setAllowAccessCategorySetting(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">{_("allowAccessTTSet")}</span>
                  <Switch
                    name="allowAccessTTSet"
                    keyAttr="task*type-setting-page"
                    isChecked={allowAccessTaskTypeSetting}
                    onChange={val => this.setAllowAccessTaskTypeSetting(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">{_("allowAccessColSet")}</span>
                  <Switch
                    name="allowAccessColSet"
                    keyAttr="collaborator-setting-page"
                    isChecked={allowAccessCollaboratorSetting}
                    onChange={val =>
                      this.setAllowAccessCollaboratorSetting(val)
                    }
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">{_("allowAccessCalSet")}</span>
                  <Switch
                    name="allowAccessCalSet"
                    keyAttr="calendar-setting-page"
                    isChecked={allowAccessCalendarSetting}
                    onChange={val => this.setAllowAccessCalendarSetting(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowCoeffConfigSet")}
                  </span>
                  <Switch
                    name="allowCoeffConfigSet"
                    keyAttr="coeff-setting-page"
                    isChecked={allowCoefficientsConfig}
                    onChange={val => this.setAllowCoefficientsConfig(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessModelSet")}
                  </span>
                  <Switch
                    name="allowAccessModelSet"
                    keyAttr="model-setting-page"
                    isChecked={allowAccessModelSetting}
                    onChange={val => this.setAllowAccessModelSetting(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessParamSet")}
                  </span>
                  <Switch
                    name="allowAccessParamSet"
                    keyAttr="parameter-setting-page"
                    isChecked={allowAccessParameterSetting}
                    onChange={val => this.setAllowAccessParameterSetting(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessUserSet")}
                  </span>
                  <Switch
                    name="allowAccessUserSet"
                    keyAttr="user-setting-page"
                    isChecked={allowAccessUserSetting}
                    onChange={val => this.setAllowAccessUserSetting(val)}
                  />
                </div>

                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessSynchronization")}
                  </span>
                  <Switch
                    name="allowAccessSync"
                    keyAttr="synchronization-page"
                    isChecked={allowAccessSynchronization}
                    onChange={val => this.setAllowAccessSynchronization(val)}
                  />
                </div>
              </div>
            </Fragment>
          )}
        </div>
      </div>
    );
  }

  render() {
    const {
      fetched,
      updating,
      role,
      settingsIsActive,
      loggedAs,
      spaceAs
    } = this.props;
    if (!fetched) {
      return null;
    }
    return (
      <div>
        <div
          id="settings__sidebar"
          className={classnames(
            styles.sidebar,
            settingsIsActive ? styles.display : "",
            inIframe() ? styles.inIframe : ""
          )}
        >
          <img
            src={"/img/icons/close.svg"}
            className={classnames(
              styles.sidebar__close,
              inIframe() ? styles.inIframe : ""
            )}
            onClick={() => this.handleCancel()}
            alt={""}
          />
          {this.renderUsers()}
          {/*<div className={styles.separator}>{_("role")}</div>*/}
          <div className={styles.switches}>
            <MultiSwitch
              labels={
                isSuperAdminAccess(loggedAs, spaceAs)
                  ? [
                      _("NONE"),
                      _("SUPERADMIN"),
                      _("ADMIN"),
                      _("PARTNER"),
                      _("COLLABORATOR"),
                      _("SUPERVISOR")
                    ]
                  : [
                      _("NONE"),
                      _("ADMIN"),
                      _("PARTNER"),
                      _("COLLABORATOR"),
                      _("SUPERVISOR")
                    ]
              }
              selectedValue={role}
              vals={
                isSuperAdminAccess(loggedAs, spaceAs)
                  ? [
                      "NONE",
                      "SUPERADMIN",
                      "ADMIN",
                      "MANAGER",
                      "COLLABORATOR",
                      "SUPERVISOR"
                    ]
                  : ["NONE", "ADMIN", "MANAGER", "COLLABORATOR", "SUPERVISOR"]
              }
              name="dashboardRole"
              onChange={val => this.setRoleValue(val)}
              customClass="sidebar_role"
            />
          </div>
          {this.renderPrivilegesBlock()}

          <div className={styles.actions_block}>
            <button
              className={styles.cancel_btn}
              onClick={() => this.handleCancel()}
            >
              {_("cancel")}
            </button>
            <button
              className={styles.save_button}
              disabled={Array.isArray(role)}
              onClick={() => this.saveUsersSettings()}
            >
              <img
                src={"/img/icons/tail-spin.svg"}
                alt={""}
                className={updating ? styles.loading : ""}
              />
              {_("save")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  role: state.authorizationsSettings.role,
  selectedUsers: state.authorizationsSettings.selectedUsers,
  users: state.authorizations.items,
  fetched: state.authorizations.fetched,
  updating: state.authorizations.updating,
  updated: state.authorizations.updated,
  activateNotifications: state.authorizationsSettings.activateNotifications,
  activateCarteNotifications:
    state.authorizationsSettings.activateCarteNotifications,
  activateCalendarNotifications:
    state.authorizationsSettings.activateCalendarNotifications,
  allowConfigurateBudget: state.authorizationsSettings.allowConfigurateBudget,
  allowUpdatingBillingView:
    state.authorizationsSettings.allowUpdatingBillingView,
  allowUpdatingTarifClients:
    state.authorizationsSettings.allowUpdatingTarifClients,
  allowUpdatingNewClients: state.authorizationsSettings.allowUpdatingNewClients,
  allowUpdatingDepartClients:
    state.authorizationsSettings.allowUpdatingDepartClients,
  allowAccessToClientCollaboratorRelation:
    state.authorizationsSettings.allowAccessToClientCollaboratorRelation,
  allowAccessToClientInformations:
    state.authorizationsSettings.allowAccessToClientInformations,
  allowAccessToGlobalBudget:
    state.authorizationsSettings.allowAccessToGlobalBudget,
  allowUpdatingOffrePrice: state.authorizationsSettings.allowUpdatingOffrePrice,
  allowToAddDeleger: state.authorizationsSettings.allowToAddDeleger,
  allowUpdateBudgetedBenchmark:
    state.authorizationsSettings.allowUpdateBudgetedBenchmark,
  allowAccessToStatisticsCards:
    state.authorizationsSettings.allowAccessToStatisticsCards,
  allowAccessToCorrectionCards:
    state.authorizationsSettings.allowAccessToCorrectionCards,
  allowVisualizationOfBudgetedTime:
    state.authorizationsSettings.allowVisualizationOfBudgetedTime,
  allowVisualizationOfBudgetedBenchmark:
    state.authorizationsSettings.allowVisualizationOfBudgetedBenchmark,
  allowVisualizationOfRealizedTime:
    state.authorizationsSettings.allowVisualizationOfRealizedTime,
  allowVisualizationOfRealizedBenchmark:
    state.authorizationsSettings.allowVisualizationOfRealizedBenchmark,

  allowAdjustDistributionOfTasksByRole:
    state.authorizationsSettings.allowAdjustDistributionOfTasksByRole,
  allowAttributionBU: state.authorizationsSettings.allowAttributionBU,
  allowAttributionSquad: state.authorizationsSettings.allowAttributionSquad,
  allowCollabToDevCard: state.authorizationsSettings.allowCollabToDevCard,
  allowAttributionCluster: state.authorizationsSettings.allowAttributionCluster,
  allowSelectAppliedModel: state.authorizationsSettings.allowSelectAppliedModel,
  allowTodragAndDropFromTODO:
    state.authorizationsSettings.allowTodragAndDropFromTODO,
  allowTodragAndDropFromWIP:
    state.authorizationsSettings.allowTodragAndDropFromWIP,
  allowTodragAndDropFromDONE:
    state.authorizationsSettings.allowTodragAndDropFromDONE,
  allowTodragAndDropFromVALIDATION:
    state.authorizationsSettings.allowTodragAndDropFromVALIDATION,

  allowAccessClientSpace: state.authorizationsSettings.allowAccessClientSpace,
  allowAccessToClientList: state.authorizationsSettings.allowAccessToClientList,
  allowAccessToCollaboratorList:
    state.authorizationsSettings.allowAccessToCollaboratorList,
  allowCreateCorrectionCards:
    state.authorizationsSettings.allowCreateCorrectionCards,

  allowAccessReporting: state.authorizationsSettings.allowAccessReporting,
  allowAccessReportingTab: state.authorizationsSettings.allowAccessReportingTab,
  allowAccessProductionCapacity:
    state.authorizationsSettings.allowAccessProductionCapacity,
  allowAccessBonusPlan: state.authorizationsSettings.allowAccessBonusPlan,
  allowAccessEcheance: state.authorizationsSettings.allowAccessEcheance,
  allowAccessBalanceRecap: state.authorizationsSettings.allowAccessBalanceRecap,
  allowAccessCalendar: state.authorizationsSettings.allowAccessCalendar,
  allowAccessTimeReport: state.authorizationsSettings.allowAccessTimeReport,
  allowAccessPortfolio: state.authorizationsSettings.allowAccessPortfolio,
  allowAccessErrReporting: state.authorizationsSettings.allowAccessErrReporting,
  allowAccessVacationMatrix:
    state.authorizationsSettings.allowAccessVacationMatrix,
  allowAccessPlans: state.authorizationsSettings.allowAccessPlans,
  allowAccessPrestation: state.authorizationsSettings.allowAccessPrestation,
  allowAccessPrestaTS: state.authorizationsSettings.allowAccessPrestaTS,
  allowAccessFinancial: state.authorizationsSettings.allowAccessFinancial,
  allowAccessFinancialSheet:
    state.authorizationsSettings.allowAccessFinancialSheet,
  allowAccessForfait: state.authorizationsSettings.allowAccessForfait,
  allowAccessCroissance: state.authorizationsSettings.allowAccessCroissance,
  allowAccessDynamicTab: state.authorizationsSettings.allowAccessDynamicTable,
  allowAccessCapacityPlanning:
    state.authorizationsSettings.allowAccessCapacityPlanning,
  allowAccessCapacityPlanningTab:
    state.authorizationsSettings.allowAccessCapacityPlanningTab,
  allowAccessSetting: state.authorizationsSettings.allowAccessSetting,
  allowAccessSynthesis: state.authorizationsSettings.allowAccessSynthesis,
  allowAccessCategorySetting:
    state.authorizationsSettings.allowAccessCategorySetting,
  allowAccessTaskTypeSetting:
    state.authorizationsSettings.allowAccessTaskTypeSetting,
  allowAccessCollaboratorSetting:
    state.authorizationsSettings.allowAccessCollaboratorSetting,
  allowAccessCalendarSetting:
    state.authorizationsSettings.allowAccessCalendarSetting,
  allowCoefficientsConfig: state.authorizationsSettings.allowCoefficientsConfig,
  allowAccessModelSetting: state.authorizationsSettings.allowAccessModelSetting,
  allowAccessUserSetting: state.authorizationsSettings.allowAccessUserSetting,
  allowAccessSynchronization:
    state.authorizationsSettings.allowAccessSynchronization,
  allowAccessParameterSetting:
    state.authorizationsSettings.allowAccessParameterSetting,
  dashboardAccess: state.authorizationsSettings.dashboard,
  clientsAccess: state.authorizationsSettings.clients,
  collaboratorsAccess: state.authorizationsSettings.collaborators,
  prestationsAccess: state.authorizationsSettings.prestations,
  notificationAccess: state.authorizationsSettings.notifications,
  cpAccess: state.authorizationsSettings.capacityPlanning,
  settingsAccess: state.authorizationsSettings.settings,
  tsAccess: state.authorizationsSettings.timesheet,
  financialAccess: state.authorizationsSettings.financial,
  reportingAccess: state.authorizationsSettings.reporting,
  parameterSettings: state.parameterSettings,
  loggedAs: selectLoggedAs(state),
  spaceAs: state.auth.spaceAs
});

export default connect(mapStateToProps)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Authorizations/SideBar.js